import {
  calculateSpendAndGetOfferTrackingData,
  deleteCookie,
  getCookie,
  isCaponeTenant,
  isCorpTenant,
  PATH_CORP_FAQ,
  PATH_PREMIUM_OFFERS_SHOP,
  setCookie,
  travelAppInterface,
  TravelAppInterfaceEventName,
  USER_MEDIUM_KEY,
  USER_SOURCE_KEY,
  type ResolveHomepageNavigationIntentFn,
  useUserContext,
  useUtmParams,
  useIsTravelApp,
  useCheckLifestyleEligibilityQuery,
  shouldCheckLifestyleEligibility,
} from "@capone/common";
import {
  useBusinessExperiments,
  useBusinessExperimentsById,
  useExperimentsById,
  stripBusinessTrackingProperties,
} from "@capone/experiments";
import {
  CarsApp,
  HotelsApp,
  FlightsApp,
  HomepageV2,
  PortalHomepageHeaderAccountNav,
  ActivitiesApp,
  PackagesApp,
  PremiumStaysApp,
  TravelWalletApp,
  VacationRentalsApp,
  CruisesApp,
} from "@capone/portal";
import {
  BusinessApp,
  CarsApp as CorpCarsApp,
  CorporateFAQ,
  CorporatePortalHomepageHeaderAccountNav,
  HotelsApp as CorpHotelsApp,
  FlightsApp as CorpFlightsApp,
  CorporateHomepageV2,
  FreeDisruptionRebookingSearchBanner,
  MyProfileApp,
  MyTripsApp as CorpMyTripsApp,
  PackagesApp as CorpPackagesApp,
  TravelWalletApp as CorpTravelWalletApp,
  VacationRentalsApp as CorpVacationRentalsApp,
} from "@capone-corporate/portal";
import Grid from "@material-ui/core/Grid";
import clsx from "clsx";
import dayjs from "dayjs";
import {
  generateUserId,
  PostBookingOfferModal,
  useDeviceTypes,
  TravelAppFTUXModal,
} from "halifax";
import React, {
  Suspense,
  useCallback,
  useEffect,
  useMemo,
  useRef,
  useState,
} from "react";
import { createPortal } from "react-dom";
import {
  Redirect,
  RouteComponentProps,
  Route as RouteV5,
  Switch,
  useHistory,
} from "react-router-dom";
import { CompatRoute, useNavigate } from "react-router-dom-v5-compat";
import {
  CallState,
  DISRUPTION_ITINERARY_ID_QUERY_PARAM,
  Funnel,
  LandingScreen,
  LAUNCHED_APPLICATION,
  LaunchedApplicationProperties,
  PostBookingScreen,
  PRODUCT_FEED_LOADING,
  ProductFeedLoadingProperties,
  RewardsAccount,
  StatementCreditDetail,
  Tenant,
  Transaction,
  WalletDetailsResponse,
  TripCategory,
  getCoreFlightsShopSubPath,
} from "redmond";

import { datadogRum } from "@datadog/browser-rum";
import queryString from "query-string";
import {
  VesperHomepageV2,
  TravelWalletApp as VesperTravelWalletApp,
} from "@vesper/portal";
import { trackEvent } from "../../api/v1/trackEvent";
import {
  addTrackingProperties,
  ANNUAL_TRAVEL_CREDITS,
  AVAILABLE,
  CARS_MAINTENANCE,
  CARS_ONLY,
  CONTROL,
  CORE_FLIGHTS,
  CORE_FLIGHTS_COTA,
  CORE_FLIGHTS_MULTICITY,
  CORE_HOMEPAGE,
  CORE_HOTELS,
  CORE_PACKAGES,
  CORP_MY_PROFILE_PAGE,
  CORP_SPEND_AND_GET_OFFER,
  CORP_MYTRIPS_REPLATFORMING,
  CUSTOMER_PROFILE_EXPERIMENT,
  CUSTOMER_PROFILE_VARIANTS,
  EXPERIENCES_EXPERIMENT,
  CRUISES_EXPERIMENT,
  FLIGHTS_MAINTENANCE,
  FLIGHTS_ONLY,
  getExperimentVariant,
  getExperimentVariantCustomVariants,
  HOTEL_CROSS_SELL_V3,
  HOTEL_CROSS_SELL_V3_VARIANTS,
  HOTELS_HOMEPAGE_CROSS_SELL_EXPERIMENT,
  HOTELS_MAINTENANCE,
  HOTELS_ONLY,
  MAINTENANCE,
  NOT_SELF_FUNDED,
  PACKAGES_EXPERIMENT,
  PACKAGES_EXPERIMENT_VARIANTS,
  PACKAGES_MAINTENANCE,
  ACTIVITIES_MAINTENANCE,
  POST_BOOKING_OFFER_EXPERIMENT,
  POST_BOOKING_OFFER_EXPERIMENT_REWARDS,
  POST_BOOKING_OFFER_MY_TRIPS,
  PREMIUM_STAYS_ONLY,
  RECENTLY_VIEWED_DESKTOP_P0_EXPERIMENT,
  RECENTLY_VIEWED_DESKTOP_P0_VARIANTS,
  RECENTLY_VIEWED_MASTER_V1,
  RECENTLY_VIEWED_MOBILE_P0_EXPERIMENT,
  RECENTLY_VIEWED_MOBILE_P0_VARIANTS,
  RECENTLY_VIEWED_V2_CARS,
  RECENTLY_VIEWED_V2_FLIGHTS,
  RESTRICT_FUNNELS,
  RESTRICT_FUNNELS_VARIANTS,
  SELF_FUNDED,
  STAYS_HOMEPAGE,
  TRAVEL_APP_GTM_EXPERIMENT,
  TRAVEL_SALE,
  TRAVEL_SALE_ACTIVE,
  TRAVEL_SALE_VARIANTS,
  TRIPS_MAINTENANCE,
  useExperiments,
  GOVERNMENT_SHUTDOWN_BANNER_TRIPS,
  CORE_ACTIVITIES,
  CORE_LUXURY_HOTELS_AVAILABILITY,
  CORE_LUXURY_HOTELS_SHOP,
  CORE_LUXURY_MOBILE_HOMEPAGE_SEARCH,
  CORE_LUXURY_VACATION_RENTALS_SHOP,
  CORE_PREMIUM_STAYS,
  CORE_VACATION_RENTALS_SHOP,
  LC_GATING_EXPERIMENT,
  PREMIER_COLLECTION_EXPERIMENT,
} from "../../context/experiments";
import { getCoreFlightsSearchQueryString } from "../../utils/queryStringHelpers";
import {
  DISPLAY_CROSS_SELL_AND_RV_PATHS,
  PATH_CARS,
  PATH_CARS_BOOK,
  PATH_BUSINESS,
  PATH_MY_PROFILE,
  PATH_CORP_ACCESS_DENIED,
  PATH_CORP_ACCESS_DENIED_NOT_BETA,
  PATH_CUSTOMER_PROFILE,
  PATH_EXCHANGE,
  PATH_ACTIVITIES,
  PATH_ACTIVITIES_BOOK,
  PATH_CRUISES,
  PATH_FAVORITES,
  PATH_FLIGHTS,
  PATH_FLIGHTS_BOOK,
  PATH_FLIGHTS_SEARCH,
  PATH_FLIGHTS_SHOP,
  PATH_FLIGHTS_SHOP_MULTICITY,
  PATH_HOME,
  PATH_HOTELS,
  PATH_HOTELS_BOOK,
  PATH_HOTELS_FLIGHTS,
  PATH_HOTELS_FLIGHTS_BOOK,
  PATH_HOTELS_FLIGHTS_BOOK_CONFIRMATION,
  PATH_HOTELS_FLIGHTS_REVIEW,
  PATH_HOTELS_FLIGHTS_SEARCH,
  PATH_HOTELS_SEARCH,
  PATH_PACKAGE_REVIEW,
  PATH_PACKAGES,
  PATH_PACKAGES_BOOK,
  PATH_PACKAGES_BOOK_CONFIRMATION,
  PATH_PACKAGES_SEARCH,
  PATH_PREMIER_COLLECTION,
  PATH_PREMIER_COLLECTION_AVAILABILITY,
  PATH_PREMIER_COLLECTION_BOOK,
  PATH_PREMIER_COLLECTION_SEARCH,
  PATH_PREMIER_COLLECTION_SHOP,
  PATH_PREMIER_COLLECTION_SHOP_DETAILS,
  PATH_PREMIER_VACATION_RENTALS,
  PATH_PREMIER_VACATION_RENTALS_AVAILABILITY,
  PATH_PREMIER_VACATION_RENTALS_SEARCH,
  PATH_PREMIER_VACATION_RENTALS_SHOP,
  PATH_PREMIER_VACATION_RENTALS_BOOK,
  PATH_SITE_TERMS_OF_USE,
  PATH_STAYS,
  PATH_STAYS_BOOK,
  PATH_STAYS_SEARCH,
  PATH_TERMS,
  PATH_TERMS_OF_SERVICE,
  PATH_TRAVEL_SALE,
  PATH_TRAVEL_WALLET,
  PATH_TRAVEL_WALLET_V2,
  PATH_TRIPS,
  PATH_TRIPS_DISRUPTION_PROTECTION_OVERVIEW,
  PATH_VACATION_RENTALS,
  PATH_VACATION_RENTALS_SHOP,
  PATH_WEBVIEW,
  PATH_DISRUPTION_OFFER,
  PATH_CFAR_OFFER,
} from "../../utils/urlPaths";
import ExchangeModule from "../ExchangeModule";
import FlightsModule from "../FlightsModule";
import HotelsModule from "../HotelsModule";
import Maintenance from "../Maintenance/maintenance";
import { LandingPageType, MobileLandingPage } from "../MobileLandingPage";
import TermsModule from "../TermsModule";
import TravelWalletModule from "../TravelWalletModule";
import TripsModule from "../TripsModule";
import useStyles from "./styles";

import { listPaymentMethods } from "../../api/v1/payment-methods/listPaymentMethods";
import { fetchBusinessAccountContext } from "../../api/v1/business/fetchBusinessAccountContext";
import getPostBookingOffer from "../../api/v1/post-booking-ancillary-offer/getPostBookingOffer";
import { fetchTravelWalletCreditHistory } from "../../api/v1/takeovers/fetchTravelWalletCreditHistory";
import { fetchTravelWalletDetails } from "../../api/v1/takeovers/fetchTravelWalletDetails";
import fetchUserFlightPreferences from "../../api/v1/user/fetchUserFlightPreferences";
import fetchUserHotelPreferences from "../../api/v1/user/fetchUserHotelPreferences";
import { useRedirectFromConsumer } from "../../hooks/useRedirectFromConsumer";
import config from "../../utils/config";
import { AccessDenied, AccessDeniedNotInBeta } from "../capone-corporate";
import { CorpHomePageBottomSection } from "../capone-corporate/CorpHomePageBottomSection/component";
import { CorpHomePageTopSection } from "../capone-corporate/CorpHomePageTopSection/component";
import {
  LegacyActivitiesBooking,
  LegacyCarsBooking,
  LegacyPackagesBooking,
  LegacyStaysBooking,
  LegacyFlightsBooking,
  LegacyPremierCollectionBook,
  LegacyPremierCollectionVRBook,
} from "../Core";
import CustomerProfileModule from "../CustomerProfileModule";
import ExperiencesModule from "../ExperiencesModule";
import { HomePage } from "../HomePage";
import { HomepageAnnualTravelCredit } from "../HomepageAnnualTravelCredit";
import { HomepageHotelCrossSell } from "../HomepageHotelCrossSell";
import { HomepageTravelSale } from "../HomepageTravelSale/component";
import PackagesModule from "../PackagesModule";
import PremierCollectionModule from "../PremierCollectionModule";
import { RecentlyViewedAndSearched } from "../RecentlyViewedAndSearched";
import VacationRentalsModule from "../VacationRentalsModule";
import { getAdsCarouselByTenant } from "../AdsCarousel";
import { CorporateSwitchModal } from "./components/CorporateSwitchModal";
import { CrossSellProps, fetchCrossSellInfoV3 } from "./cross-sell-helpers";
import {
  fetchRecentlyViewedAndSearched,
  RecentlyViewedAndSearchedProps,
} from "./recently-viewed-and-searched-helpers";
import "./styles.scss";
import { createHomepageNavigationResolver } from "./homepageNavigationResolver";

const getCarsAppByTenant = (tenant: Tenant) => {
  switch (tenant) {
    case "capone":
      return <CarsApp />;
    case "brex":
    case "capone-corporate":
      return <CorpCarsApp />;
    default:
      return <CarsApp />;
  }
};
const getHotelsAppByTenant = (tenant: Tenant) => {
  switch (tenant) {
    case "capone":
      return <HotelsApp />;
    case "brex":
    case "capone-corporate":
      return <CorpHotelsApp />;
    default:
      return <HotelsApp />;
  }
};
const getHomepageByTenant = (
  tenant: Tenant,
  resolveNavigationIntent: ResolveHomepageNavigationIntentFn,
  activeFunnel?: React.ComponentProps<typeof HomepageV2>["activeFunnel"],
  homepageProps?: Pick<
    React.ComponentProps<typeof HomepageV2>,
    | "maintenanceBannerText"
    | "maintenanceFunnels"
    | "maintenanceTitle"
    | "maintenanceSubtext"
    | "isHAMode"
  >,
  corpHomepageProps?: Pick<
    React.ComponentProps<typeof CorporateHomepageV2>,
    "isSameDayRoundTripModalOpen" | "onSameDayRoundTripModalClose"
  >
) => {
  if (isCorpTenant(tenant)) {
    return (
      <CorporateHomepageV2
        activeFunnel={activeFunnel}
        resolveNavigationIntent={resolveNavigationIntent}
        {...homepageProps}
        {...corpHomepageProps}
      />
    );
  }

  if (tenant === "vesper") {
    return (
      <VesperHomepageV2
        activeFunnel={activeFunnel}
        resolveNavigationIntent={resolveNavigationIntent}
        {...homepageProps}
      />
    );
  }
  return (
    <HomepageV2
      activeFunnel={activeFunnel}
      resolveNavigationIntent={resolveNavigationIntent}
      {...homepageProps}
    />
  );
};

const DEFAULT_MAINTENANCE_BANNER_TEXT =
  "Service currently unavailable due to scheduled maintenance.";
const REWARDS_DISABLED_BANNER_TEXT =
  "Rewards redemptions are temporarily unavailable. Card purchases will still earn rewards normally.";
const DEFAULT_MAINTENANCE_TITLE = "We'll be back soon";
const DEFAULT_MAINTENANCE_SUBTEXT =
  "Service currently unavailable due to scheduled maintenance.";
const DEFAULT_HOMEPAGE_MAINTENANCE_PROPS = {
  maintenanceTitle: DEFAULT_MAINTENANCE_TITLE,
  maintenanceSubtext: DEFAULT_MAINTENANCE_SUBTEXT,
} as const;

const getFlightsAppByTenant = (tenant: Tenant) => {
  switch (tenant) {
    case "brex":
    case "capone-corporate":
      return <CorpFlightsApp />;
    case "capone":
    default:
      return <FlightsApp />;
  }
};

const getActivitiesAppByTenant = (_: Tenant) => <ActivitiesApp />;

const getCruisesAppByTenant = (_: Tenant) => <CruisesApp />;

const getPremiumStaysAppByTenant = (_: Tenant) => <PremiumStaysApp />;

const getTravelWalletAppByTenant = (tenant: Tenant) => {
  switch (tenant) {
    case "brex":
    case "capone-corporate":
      return <CorpTravelWalletApp />;
    case "vesper":
      return <VesperTravelWalletApp />;
    default:
      return <TravelWalletApp />;
  }
};

const getPackagesAppByTenant = (tenant: Tenant) => {
  switch (tenant) {
    case "brex":
    case "capone-corporate":
      return <CorpPackagesApp />;
    default:
      return <PackagesApp />;
  }
};

const getVacationRentalsAppByTenant = (tenant: Tenant) => {
  switch (tenant) {
    case "brex":
    case "capone-corporate":
      return <CorpVacationRentalsApp />;
    default:
      return <VacationRentalsApp />;
  }
};

interface IBodyProps {
  language: string;
  className?: string;
  isFirstSession: boolean;
  launchEventSent: boolean;
  setLaunchEventSent: (val: boolean) => void;
  rewardsAccounts: RewardsAccount[];
  selectedRewardsAccountId: string | null;
  fetchRewardsAccountsCallState: CallState;
  pathname: string;
  notAuthenticated?: boolean;
  showCoreHomepage: boolean;
  coreHomepageVariant: string;
  businessEligibilityStatus?: "unknown" | "eligible" | "ineligible";
  consumerAccessStatus?: "unknown" | "single-portal" | "multiportal";
  isSameDayRoundTripModalOpen?: boolean;
  onSameDayRoundTripModalClose?: () => void;
}

const CORE_HOMEPAGE_UNEXPECTED_VIEW_EVENT = "core_homepage_unexpected_view";

const getCoreHomepageUnexpectedReasons = ({
  coreHomepageVariant,
  businessEligibilityStatus,
  consumerAccessStatus,
}: Pick<
  IBodyProps,
  "coreHomepageVariant" | "businessEligibilityStatus" | "consumerAccessStatus"
>) => {
  const unexpectedReasons: string[] = [];

  if (!coreHomepageVariant.startsWith(AVAILABLE)) {
    unexpectedReasons.push("experiment_off");
  }

  if (businessEligibilityStatus === "eligible") {
    unexpectedReasons.push("business_eligible");
  }

  if (consumerAccessStatus === "multiportal") {
    unexpectedReasons.push("consumer_multiportal_access");
  }

  return unexpectedReasons;
};

type CoreHomepageTrackingProps = Pick<
  IBodyProps,
  "coreHomepageVariant" | "businessEligibilityStatus" | "consumerAccessStatus"
> & {
  activeFunnel?: React.ComponentProps<typeof HomepageV2>["activeFunnel"];
  pathname: string;
  children: React.ReactNode;
};

const CoreHomepageTracking = ({
  activeFunnel,
  pathname,
  coreHomepageVariant,
  businessEligibilityStatus,
  consumerAccessStatus,
  children,
}: CoreHomepageTrackingProps) => {
  const hasTracked = useRef(false);

  useEffect(() => {
    if (hasTracked.current) {
      return;
    }

    const unexpectedReasons = getCoreHomepageUnexpectedReasons({
      coreHomepageVariant,
      businessEligibilityStatus,
      consumerAccessStatus,
    });

    if (unexpectedReasons.length === 0) {
      return;
    }

    hasTracked.current = true;

    trackEvent({
      eventName: CORE_HOMEPAGE_UNEXPECTED_VIEW_EVENT,
      properties: {
        active_funnel: activeFunnel ?? "",
        business_eligibility_status: businessEligibilityStatus ?? "",
        consumer_access_status: consumerAccessStatus ?? "",
        core_homepage_expected_to_render: false,
        core_homepage_variant: coreHomepageVariant,
        reason_business_eligible:
          unexpectedReasons.includes("business_eligible"),
        reason_consumer_multiportal_access: unexpectedReasons.includes(
          "consumer_multiportal_access"
        ),
        reason_experiment_off: unexpectedReasons.includes("experiment_off"),
        tenant: config.TENANT,
        unexpected_reasons: unexpectedReasons.join(","),
        url: pathname,
      },
    });
  }, [
    activeFunnel,
    businessEligibilityStatus,
    consumerAccessStatus,
    coreHomepageVariant,
    pathname,
  ]);

  return <>{children}</>;
};

const FLIGHTS_HOMEPAGE_HEADER_ACCOUNT_NAV_SLOT_ID =
  "flights-homepage-header-account-nav-slot";
const PACKAGES_HOMEPAGE_HEADER_ACCOUNT_NAV_SLOT_ID =
  "packages-homepage-header-account-nav-slot";
const VACATION_RENTALS_HOMEPAGE_HEADER_ACCOUNT_NAV_SLOT_ID =
  "vacation-rentals-homepage-header-account-nav-slot";
const PREMIER_COLLECTION_HOMEPAGE_HEADER_ACCOUNT_NAV_SLOT_ID =
  "premier-collection-homepage-header-account-nav-slot";
const ACTIVITIES_HOMEPAGE_HEADER_ACCOUNT_NAV_SLOT_ID =
  "activities-homepage-header-account-nav-slot";

const usePortalSlot = (slotId: string, active: boolean) => {
  const [target, setTarget] = useState<HTMLElement | null>(null);

  useEffect(() => {
    if (!active) {
      setTarget(null);
      return;
    }

    const resolveTarget = () => {
      const nextTarget = document.getElementById(slotId);
      setTarget((prevTarget) =>
        prevTarget === nextTarget ? prevTarget : nextTarget
      );
    };

    resolveTarget();

    const observer = new MutationObserver(resolveTarget);
    observer.observe(document.body, {
      childList: true,
      subtree: true,
    });

    return () => {
      observer.disconnect();
    };
  }, [active, slotId]);

  return active ? target : null;
};

const HomepageHeaderAccountNavPortal = ({
  active,
  slotId,
}: {
  active: boolean;
  slotId: string;
}) => {
  const AccountNavComponent = isCorpTenant(config.TENANT)
    ? CorporatePortalHomepageHeaderAccountNav
    : PortalHomepageHeaderAccountNav;
  const target = usePortalSlot(slotId, active);

  if (target == null) {
    return null;
  }

  return createPortal(<AccountNavComponent />, target);
};

const FDR_SEARCH_BANNER_SLOT_ID = "fdr-search-banner-slot";

const FdrSearchBannerPortal = ({ active }: { active: boolean }) => {
  const target = usePortalSlot(FDR_SEARCH_BANNER_SLOT_ID, active);

  if (target == null) {
    return null;
  }

  return createPortal(<FreeDisruptionRebookingSearchBanner />, target);
};

const Body = (props: IBodyProps) => {
  const {
    language,
    className,
    isFirstSession,
    launchEventSent,
    setLaunchEventSent,
    rewardsAccounts,
    selectedRewardsAccountId,
    fetchRewardsAccountsCallState,
    pathname,
    notAuthenticated,
    showCoreHomepage,
    coreHomepageVariant,
    businessEligibilityStatus,
    consumerAccessStatus,
    isSameDayRoundTripModalOpen,
    onSameDayRoundTripModalClose,
  } = props;
  const { sessionInfo, isRewardsDisabled } = useUserContext(config.TENANT);
  const { matchesMobile } = useDeviceTypes();
  const expState = useExperiments();
  const portalMaintenanceExperiment = useExperimentsById(
    "cap1-portal-maintenance"
  );
  const travelerMaintenanceExperiment = useExperimentsById(
    "corp-traveler-maintenance"
  );

  const packagesPath = isCorpTenant(config.TENANT)
    ? PATH_HOTELS_FLIGHTS
    : PATH_PACKAGES;
  const packagesSearchPath = isCorpTenant(config.TENANT)
    ? PATH_HOTELS_FLIGHTS_SEARCH
    : PATH_PACKAGES_SEARCH;
  const businessExpState = useBusinessExperiments();
  const freeFdaVariant = useBusinessExperimentsById("corp-free-fda")?.variant;
  const isFreeFdaEnabled =
    freeFdaVariant === "available" || freeFdaVariant === "available_phase2";
  const classes = useStyles();
  const utmParams = useUtmParams();
  const history = useHistory();
  const navigate = useNavigate();
  const { isTravelApp } = useIsTravelApp();

  const goToDisruptionProtection = useCallback(
    (itineraryId: string) => {
      const search = new URLSearchParams({
        [DISRUPTION_ITINERARY_ID_QUERY_PARAM]: itineraryId,
      });
      history.push({
        pathname: PATH_TRIPS_DISRUPTION_PROTECTION_OVERVIEW,
        search: search.toString(),
      });
    },
    [history]
  );

  const [fetchedWalletDetails, setFetchedWalletDetails] = useState(false);
  const [fetchedPaymentsList, setFetchedPaymentsList] = useState({
    fetched: false,
    hasCardOnFile: false,
  });
  const [walletDetails, setWalletDetails] =
    useState<WalletDetailsResponse | null>(null);
  const [creditHistory, setCreditHistory] = useState<Transaction[] | null>(
    null
  );
  const [onPortalSpend, setOnPortalSpend] = useState<number | null>(null);
  const [crossSellProps, setCrossSellProps] = useState<CrossSellProps | null>(
    null
  );
  const [crossSellLoaded, setCrossSellLoaded] = useState<boolean>(false);
  const [recentlyViewedAndSearchedProps, setRecentlyViewedAndSearchedProps] =
    useState<RecentlyViewedAndSearchedProps | null>(null);
  const [recentlyViewedLoaded, setRecentlyViewedLoaded] =
    useState<boolean>(false);
  const [, setUserHasNotSetHotelPreferences] = useState<boolean>(false);
  const [, setUserHasNotSetFlightPreferences] = useState<boolean>(false);
  const [showCrossSellV3UI, setShowCrossSellV3UI] = useState<boolean>(false);
  const [atcBannerVisible, setAtcBannerVisible] = useState<boolean>(false);
  const [openTravelCreditFTUX, setOpenTravelCreditFTUX] =
    useState<boolean>(false);

  // Only check API for corporate tenant with lifestyle-eligible cards
  const shouldCheckEligibility = shouldCheckLifestyleEligibility(
    isCorpTenant(config.TENANT),
    rewardsAccounts
  );

  const { data: eligibilityData, isLoading: isCheckingEligibility } =
    useCheckLifestyleEligibilityQuery(undefined, {
      skip: !shouldCheckEligibility,
    });
  const isLifestyleEligible = shouldCheckEligibility
    ? eligibilityData?.isEligible ?? null
    : false;

  const { showCorporateSwitchModal } = useRedirectFromConsumer(
    rewardsAccounts,
    fetchRewardsAccountsCallState
  );

  const isInMaintenance =
    getExperimentVariant(expState.experiments, MAINTENANCE) === AVAILABLE;
  const flightsMaintenance =
    getExperimentVariant(expState.experiments, FLIGHTS_MAINTENANCE) ===
    AVAILABLE;
  const hotelsMaintenance =
    getExperimentVariant(expState.experiments, HOTELS_MAINTENANCE) ===
    AVAILABLE;
  const carsMaintenance =
    getExperimentVariant(expState.experiments, CARS_MAINTENANCE) === AVAILABLE;
  const tripsMaintenance =
    getExperimentVariant(expState.experiments, TRIPS_MAINTENANCE) === AVAILABLE;
  const packagesMaintenance =
    getExperimentVariant(expState.experiments, PACKAGES_MAINTENANCE) ===
    AVAILABLE;
  const activitiesMaintenance =
    getExperimentVariant(expState.experiments, ACTIVITIES_MAINTENANCE) ===
    AVAILABLE;
  const homepageMaintenanceFunnels = {
    Activities: "Activities",
    PremiumStays: "PremiumStays",
  } as const satisfies Record<
    string,
    NonNullable<React.ComponentProps<typeof HomepageV2>["activeFunnel"]>
  >;
  const homepageMaintenanceExperiment =
    isCorpTenant(config.TENANT)
      ? travelerMaintenanceExperiment
      : portalMaintenanceExperiment;
  const isMaintenanceBannerVariantActive =
    homepageMaintenanceExperiment?.variant === "banner";
  const isHAMode = isRewardsDisabled && !isMaintenanceBannerVariantActive;
  const maintenanceBannerText = useMemo(() => {
    if (isMaintenanceBannerVariantActive) {
      return (
        homepageMaintenanceExperiment.data?.title ||
        homepageMaintenanceExperiment.data?.subtext ||
        DEFAULT_MAINTENANCE_BANNER_TEXT
      );
    }

    if (isRewardsDisabled) {
      return REWARDS_DISABLED_BANNER_TEXT;
    }

    return undefined;
  }, [
    homepageMaintenanceExperiment,
    isMaintenanceBannerVariantActive,
    isRewardsDisabled,
  ]);
  const maintenanceFunnels = useMemo(
    () => ({
      [Funnel.Air]: flightsMaintenance,
      [Funnel.Lodging]: hotelsMaintenance,
      [homepageMaintenanceFunnels.PremiumStays]: hotelsMaintenance,
      [Funnel.Ground]: carsMaintenance,
      [Funnel.Package]: packagesMaintenance,
      [homepageMaintenanceFunnels.Activities]: activitiesMaintenance,
    }),
    [
      activitiesMaintenance,
      carsMaintenance,
      flightsMaintenance,
      hotelsMaintenance,
      homepageMaintenanceFunnels.Activities,
      homepageMaintenanceFunnels.PremiumStays,
      packagesMaintenance,
    ]
  );
  const homepageProps = useMemo(
    () => ({
      maintenanceBannerText,
      maintenanceFunnels,
      isHAMode,
      ...DEFAULT_HOMEPAGE_MAINTENANCE_PROPS,
    }),
    [maintenanceBannerText, maintenanceFunnels, isHAMode]
  );

  const corpHomepageProps = useMemo(
    () => ({
      isSameDayRoundTripModalOpen,
      onSameDayRoundTripModalClose,
    }),
    [isSameDayRoundTripModalOpen, onSameDayRoundTripModalClose]
  );

  // Get government shutdown banner experiment variant for post-booking modal
  const postBookingGovernmentShutdownVariant = getExperimentVariant(
    expState.experiments,
    GOVERNMENT_SHUTDOWN_BANNER_TRIPS
  );

  const travelSaleVariant = getExperimentVariantCustomVariants(
    expState.experiments,
    TRAVEL_SALE,
    TRAVEL_SALE_VARIANTS
  );

  const isTravelSaleEnabled = travelSaleVariant !== CONTROL;

  const isLifestyleCollectionEnabled =
    getExperimentVariant(expState.experiments, LC_GATING_EXPERIMENT) ===
    AVAILABLE;

  const isPremierCollectionEnabled =
    getExperimentVariant(
      expState.experiments,
      PREMIER_COLLECTION_EXPERIMENT
    ) === AVAILABLE;

  const isHotelCrossSellExperiment =
    getExperimentVariant(
      expState.experiments,
      HOTELS_HOMEPAGE_CROSS_SELL_EXPERIMENT
    ) === AVAILABLE;

  const isRecentlyViewedV1Experiment =
    getExperimentVariant(expState.experiments, RECENTLY_VIEWED_MASTER_V1) ===
    AVAILABLE;

  const recentlyViewedDesktopP0Variant = getExperimentVariantCustomVariants(
    expState.experiments,
    RECENTLY_VIEWED_DESKTOP_P0_EXPERIMENT,
    RECENTLY_VIEWED_DESKTOP_P0_VARIANTS
  );

  const recentlyViewedMobileP0Variant = getExperimentVariantCustomVariants(
    expState.experiments,
    RECENTLY_VIEWED_MOBILE_P0_EXPERIMENT,
    RECENTLY_VIEWED_MOBILE_P0_VARIANTS
  );
  const isRecentlyViewedFlightsV2 =
    getExperimentVariant(expState.experiments, RECENTLY_VIEWED_V2_FLIGHTS) ===
    AVAILABLE;

  const isRecentlyViewedCarsV2 =
    getExperimentVariant(expState.experiments, RECENTLY_VIEWED_V2_CARS) ===
    AVAILABLE;

  const isAnnualTravelCreditsExperiment =
    getExperimentVariant(expState.experiments, ANNUAL_TRAVEL_CREDITS) ===
    AVAILABLE;

  const isPostBookingOffersAvailable = getExperimentVariant(
    expState.experiments,
    POST_BOOKING_OFFER_EXPERIMENT
  ).startsWith(AVAILABLE);

  const showPostBookingPayByRewardsMerch =
    getExperimentVariant(
      expState.experiments,
      POST_BOOKING_OFFER_EXPERIMENT_REWARDS
    ) === "available-with-merch";

  const isDisruptionAirCopyAvailable = getExperimentVariant(
    expState.experiments,
    POST_BOOKING_OFFER_EXPERIMENT
  ).startsWith(AVAILABLE);

  const isPostBookingMyTripsBannerAvailable = getExperimentVariant(
    expState.experiments,
    POST_BOOKING_OFFER_MY_TRIPS
  ).startsWith(AVAILABLE);

  const isCustomerProfileExperiment =
    getExperimentVariantCustomVariants(
      expState.experiments,
      CUSTOMER_PROFILE_EXPERIMENT,
      CUSTOMER_PROFILE_VARIANTS
    ) !== CONTROL;

  const packagesExperimentVariant = getExperimentVariantCustomVariants(
    expState.experiments,
    PACKAGES_EXPERIMENT,
    PACKAGES_EXPERIMENT_VARIANTS
  );

  const isPackagesExperiment = [SELF_FUNDED, NOT_SELF_FUNDED].includes(
    packagesExperimentVariant
  );

  const isExperiencesExperiment =
    getExperimentVariant(expState.experiments, EXPERIENCES_EXPERIMENT) ===
    AVAILABLE;

  const isHotelCrossSellV3Enabled =
    getExperimentVariantCustomVariants(
      expState.experiments,
      HOTEL_CROSS_SELL_V3,
      HOTEL_CROSS_SELL_V3_VARIANTS
    ) !== CONTROL;

  const restrictFunnelVariant = getExperimentVariantCustomVariants(
    expState.experiments,
    RESTRICT_FUNNELS,
    RESTRICT_FUNNELS_VARIANTS
  );

  const staysHomepageEnabled =
    getExperimentVariant(expState.experiments, STAYS_HOMEPAGE) === AVAILABLE;

  const shouldRestrictFunnels = restrictFunnelVariant != CONTROL;

  const showFlightsFunnel =
    !shouldRestrictFunnels || restrictFunnelVariant == FLIGHTS_ONLY;
  const showHotelsFunnel =
    !shouldRestrictFunnels || restrictFunnelVariant == HOTELS_ONLY;
  const showPremiumStaysFunnel =
    !shouldRestrictFunnels || restrictFunnelVariant == PREMIUM_STAYS_ONLY;

  const postBookingOfferModalConnectorPropsPropsShowOnPaths = useMemo(() => {
    const arr: {
      path: string;
      screen: PostBookingScreen;
    }[] = [
      { path: PATH_HOTELS, screen: "hotel_homepage" },
      { path: PATH_FLIGHTS, screen: "air_homepage" },
      { path: PATH_HOME, screen: "hotel_homepage" },
    ];

    if (!isPostBookingMyTripsBannerAvailable) {
      arr.push({
        path: PATH_TRIPS,
        screen: "my_trips_homepage",
      });
    }

    return arr;
  }, [isPostBookingMyTripsBannerAvailable]);

  const getLandingPageType = () => {
    switch (restrictFunnelVariant) {
      case CARS_ONLY:
        return LandingPageType.CARS;
      case FLIGHTS_ONLY:
        return LandingPageType.FLIGHTS;
      case HOTELS_ONLY:
        return LandingPageType.HOTELS;
      case PREMIUM_STAYS_ONLY:
        return LandingPageType.PREMIUM_STAYS;
      case CONTROL:
      default:
        return LandingPageType.HOTELS;
    }
  };

  const getRedirectPath = () => {
    switch (restrictFunnelVariant) {
      case CARS_ONLY:
        return PATH_CARS;
      case FLIGHTS_ONLY:
        return PATH_FLIGHTS;
      case HOTELS_ONLY:
        return `${PATH_STAYS}${window.location.search}`;
      case PREMIUM_STAYS_ONLY:
        return PATH_PREMIER_COLLECTION;
      case CONTROL:
      default:
        return `${PATH_STAYS}${window.location.search}`;
    }
  };

  const showCoreHotels = getExperimentVariant(
    expState.experiments,
    CORE_HOTELS
  ).startsWith(AVAILABLE);

  const showCoreFlights = useMemo(() => {
    const isReplatformEnabled = getExperimentVariant(
      expState.experiments,
      isTravelApp ? CORE_FLIGHTS_COTA : CORE_FLIGHTS
    ).startsWith(AVAILABLE);

    const isMultiCityReplatformEnabled = getExperimentVariant(
      expState.experiments,
      CORE_FLIGHTS_MULTICITY
    ).startsWith(AVAILABLE);

    const isMultiCityPath = pathname.startsWith(PATH_FLIGHTS_SHOP_MULTICITY);

    const parsed = queryString.parse(window.location.search);
    const isMultiCityTrip = parsed.tripCategory === TripCategory.MULTI_CITY;
    const isSingleTrip = !isMultiCityPath && !isMultiCityTrip;

    // Multi-city stays on the legacy shop unless the multi-city replatform
    // experiment is available; single-trip continues to gate on CORE_FLIGHTS.
    return (
      isReplatformEnabled && (isSingleTrip || isMultiCityReplatformEnabled)
    );
  }, [expState.experiments, pathname, isTravelApp]);

  const showCoreActivities = getExperimentVariant(
    expState.experiments,
    CORE_ACTIVITIES
  ).startsWith(AVAILABLE);

  // Mirror the homepage/terms-page Cruises tab gating (see capone/App.tsx and
  // funnelTabs.ts): the funnel is reachable unless the experiment is in
  // control, so the route must use the same check or reachable sub-paths
  // (e.g. /cruises/availability) fall through to the catch-all redirect.
  const showCoreCruises =
    getExperimentVariant(expState.experiments, CRUISES_EXPERIMENT) !== CONTROL;

  const showCorePackages = getExperimentVariant(
    expState.experiments,
    CORE_PACKAGES
  ).startsWith(AVAILABLE);

  const normalizedPathname = pathname.endsWith("/") ? pathname : `${pathname}/`;

  const showCorePremiumStays = useMemo(() => {
    const isReplatformEnabled = getExperimentVariant(
      expState.experiments,
      CORE_PREMIUM_STAYS
    ).startsWith(AVAILABLE);

    // Only enable new app for routes it actually handles
    return (
      isReplatformEnabled &&
      normalizedPathname.startsWith(PATH_PREMIER_VACATION_RENTALS_AVAILABILITY)
    );
  }, [expState.experiments, normalizedPathname]);

  const showCoreLuxuryHotelsShop = useMemo(() => {
    const isReplatformEnabled = getExperimentVariant(
      expState.experiments,
      CORE_LUXURY_HOTELS_SHOP
    ).startsWith(AVAILABLE);

    // Only enable new app for routes it actually handles
    return (
      isReplatformEnabled &&
      normalizedPathname.startsWith(PATH_PREMIER_COLLECTION_SHOP)
    );
  }, [expState.experiments, normalizedPathname]);

  const showCoreLuxuryHotelsAvailability = useMemo(() => {
    const isReplatformEnabled = getExperimentVariant(
      expState.experiments,
      CORE_LUXURY_HOTELS_AVAILABILITY
    ).startsWith(AVAILABLE);

    // Only enable new app for routes it actually handles
    return (
      isReplatformEnabled &&
      normalizedPathname.startsWith(PATH_PREMIER_COLLECTION_AVAILABILITY)
    );
  }, [expState.experiments, normalizedPathname]);

  const showCoreLuxuryHotelsShopDetails = useMemo(() => {
    const isReplatformEnabled = getExperimentVariant(
      expState.experiments,
      CORE_LUXURY_HOTELS_SHOP
    ).startsWith(AVAILABLE);

    // Only enable new app for routes it actually handles
    return (
      isReplatformEnabled &&
      normalizedPathname.startsWith(PATH_PREMIER_COLLECTION_SHOP_DETAILS)
    );
  }, [expState.experiments, normalizedPathname]);

  const showCoreVacationRentalsShop = useMemo(() => {
    const isReplatformEnabled = getExperimentVariant(
      expState.experiments,
      CORE_VACATION_RENTALS_SHOP
    ).startsWith(AVAILABLE);

    return (
      isReplatformEnabled &&
      normalizedPathname.startsWith(PATH_VACATION_RENTALS_SHOP)
    );
  }, [expState.experiments, normalizedPathname]);

  const showCoreLuxuryVacationRentalsShop = useMemo(() => {
    const isReplatformEnabled = getExperimentVariant(
      expState.experiments,
      CORE_LUXURY_VACATION_RENTALS_SHOP
    ).startsWith(AVAILABLE);

    // Only enable new app for routes it actually handles
    return (
      isReplatformEnabled &&
      normalizedPathname.startsWith(PATH_PREMIER_VACATION_RENTALS_SHOP)
    );
  }, [expState.experiments, normalizedPathname]);

  const showCoreLuxuryMobileHomepageSearch = useMemo(() => {
    const isReplatformEnabled = getExperimentVariant(
      expState.experiments,
      CORE_LUXURY_MOBILE_HOMEPAGE_SEARCH
    ).startsWith(AVAILABLE);

    // Replatform of the premium stays search pages (hotels + VR)
    return (
      isReplatformEnabled &&
      (normalizedPathname.startsWith(PATH_PREMIER_COLLECTION_SEARCH) ||
        normalizedPathname.startsWith(PATH_PREMIER_VACATION_RENTALS_SEARCH))
    );
  }, [expState.experiments, normalizedPathname]);

  const showCorpMyTrips = getExperimentVariant(
    expState.experiments,
    CORP_MYTRIPS_REPLATFORMING
  ).startsWith(AVAILABLE) && isCorpTenant(config.TENANT);

  const isMyProfilePageResolved =
    [CallState.Success, CallState.Failed].includes(expState.callState) ||
    expState.experiments.length > 0;
  const isMyProfilePageAvailable =
    getExperimentVariant(expState.experiments, CORP_MY_PROFILE_PAGE) ===
    AVAILABLE;

  // Route the PC book page through the direct-import Legacy wrapper (which
  // injects `core` via usePremiumStaysCheckoutProps) only when the Core lux
  // hotels shop is enabled. When it's off, the legacy microfrontend serves the
  // entire funnel (including book) end-to-end, mirroring the activities pattern.
  const showCorePremiumStaysBook = useMemo(() => {
    const isReplatformEnabled = getExperimentVariant(
      expState.experiments,
      CORE_LUXURY_HOTELS_SHOP
    ).startsWith(AVAILABLE);

    return (
      isReplatformEnabled &&
      normalizedPathname.startsWith(PATH_PREMIER_COLLECTION_BOOK)
    );
  }, [expState.experiments, normalizedPathname]);

  const showCorePremiumStaysVrBook = useMemo(() => {
    const isReplatformEnabled = getExperimentVariant(
      expState.experiments,
      CORE_LUXURY_VACATION_RENTALS_SHOP
    ).startsWith(AVAILABLE);

    return (
      isReplatformEnabled &&
      normalizedPathname.startsWith(PATH_PREMIER_VACATION_RENTALS_BOOK)
    );
  }, [expState.experiments, normalizedPathname]);

  const isTravelAppGTMEnabled =
    getExperimentVariant(expState.experiments, TRAVEL_APP_GTM_EXPERIMENT) ===
    AVAILABLE;

  const resolveHomepageNavigationIntent = useMemo(
    () =>
      createHomepageNavigationResolver({
        isCorporateTenant: isCorpTenant(config.TENANT),
        showCorePackages,
      }),
    [showCoreFlights, showCorePackages]
  );

  const renderCoreHomepage = (
    routePathname: string,
    activeFunnel?: React.ComponentProps<typeof HomepageV2>["activeFunnel"]
  ) => {
    const homepage = getHomepageByTenant(
      config.TENANT,
      resolveHomepageNavigationIntent,
      activeFunnel,
      homepageProps,
      corpHomepageProps
    );
    return (
      <CoreHomepageTracking
        activeFunnel={activeFunnel}
        pathname={routePathname}
        coreHomepageVariant={coreHomepageVariant}
        businessEligibilityStatus={businessEligibilityStatus}
        consumerAccessStatus={consumerAccessStatus}
      >
        {homepage}
      </CoreHomepageTracking>
    );
  };

  datadogRum.addFeatureFlagEvaluation(
    CORE_HOMEPAGE.replaceAll("-", ""),
    getExperimentVariant(expState.experiments, CORE_HOMEPAGE)
  );
  datadogRum.addFeatureFlagEvaluation(
    CORE_HOTELS.replaceAll("-", ""),
    getExperimentVariant(expState.experiments, CORE_HOTELS)
  );
  datadogRum.addFeatureFlagEvaluation(
    CORE_FLIGHTS.replaceAll("-", ""),
    getExperimentVariant(expState.experiments, CORE_FLIGHTS)
  );
  datadogRum.addFeatureFlagEvaluation(
    CORE_FLIGHTS_COTA.replaceAll("-", ""),
    getExperimentVariant(expState.experiments, CORE_FLIGHTS_COTA)
  );
  datadogRum.addFeatureFlagEvaluation(
    CORE_FLIGHTS_MULTICITY.replaceAll("-", ""),
    getExperimentVariant(expState.experiments, CORE_FLIGHTS_MULTICITY)
  );
  datadogRum.addFeatureFlagEvaluation(
    CORE_ACTIVITIES.replaceAll("-", ""),
    getExperimentVariant(expState.experiments, CORE_ACTIVITIES)
  );
  datadogRum.addFeatureFlagEvaluation(
    CORE_PACKAGES.replaceAll("-", ""),
    getExperimentVariant(expState.experiments, CORE_PACKAGES)
  );
  datadogRum.addFeatureFlagEvaluation(
    CORE_PREMIUM_STAYS.replaceAll("-", ""),
    getExperimentVariant(expState.experiments, CORE_PREMIUM_STAYS)
  );
  datadogRum.addFeatureFlagEvaluation(
    CORE_LUXURY_HOTELS_SHOP.replaceAll("-", ""),
    getExperimentVariant(expState.experiments, CORE_LUXURY_HOTELS_SHOP)
  );
  datadogRum.addFeatureFlagEvaluation(
    CORE_LUXURY_HOTELS_AVAILABILITY.replaceAll("-", ""),
    getExperimentVariant(expState.experiments, CORE_LUXURY_HOTELS_AVAILABILITY)
  );
  datadogRum.addFeatureFlagEvaluation(
    CORE_LUXURY_MOBILE_HOMEPAGE_SEARCH.replaceAll("-", ""),
    getExperimentVariant(
      expState.experiments,
      CORE_LUXURY_MOBILE_HOMEPAGE_SEARCH
    )
  );
  datadogRum.addFeatureFlagEvaluation(
    CORE_VACATION_RENTALS_SHOP.replaceAll("-", ""),
    getExperimentVariant(expState.experiments, CORE_VACATION_RENTALS_SHOP)
  );

  useEffect(() => {
    setShowCrossSellV3UI(
      isHotelCrossSellV3Enabled && !!crossSellProps?.tysonsOffer
    );
  }, [crossSellProps]);

  const isSpendAndGetOfferEnabled =
    getExperimentVariant(expState.experiments, CORP_SPEND_AND_GET_OFFER) ===
    AVAILABLE;

  useEffect(() => {
    if (!expState.trackingProperties || sessionInfo.userId.length <= 0) {
      return;
    }

    const fetchWalletData = async () => {
      const shouldFetchSpendAndGetOfferData =
        isCorpTenant(config.TENANT) && isSpendAndGetOfferEnabled;

      const [walletDetailsResult, creditHistoryResult, onPortalSpendResult] =
        await Promise.all([
          fetchTravelWalletDetails().catch(() => null),
          shouldFetchSpendAndGetOfferData
            ? fetchTravelWalletCreditHistory()
                .then((res) => res?.credits ?? null)
                .catch(() => null)
            : Promise.resolve(null),
          shouldFetchSpendAndGetOfferData
            ? fetchBusinessAccountContext().catch(() => null)
            : Promise.resolve(null),
        ]);

      setWalletDetails(walletDetailsResult);
      setCreditHistory(creditHistoryResult);
      setOnPortalSpend(onPortalSpendResult);
      setFetchedWalletDetails(true);
    };

    fetchWalletData();
  }, [
    expState.trackingProperties,
    isSpendAndGetOfferEnabled,
    sessionInfo.userId,
  ]);

  useEffect(() => {
    const doLaunch = async () => {
      if (
        !isFirstSession &&
        !launchEventSent &&
        sessionInfo?.csrfToken &&
        fetchedWalletDetails &&
        expState.trackingProperties
      ) {
        let account = null;
        let properties: LaunchedApplicationProperties = {
          landing_screen: getLandingScreen(),
          url: window.location.pathname,
          rewards_accounts: "",
          has_credits: !!walletDetails?.credit?.amount?.amount,
          credit_balance: walletDetails?.credit?.amount?.amount || 0,
          vx_statement_credit_balance:
            walletDetails?.creditBreakdown
              ?.filter((b) => b.CreditDetail === "Statement")
              .reduce(
                (prev, curr) =>
                  prev + (curr as StatementCreditDetail).usableAmount.amount,
                0
              ) || 0,
        };

        if (utmParams) {
          const { userSource, userMedium } = utmParams;
          properties[USER_SOURCE_KEY] =
            userSource ?? sessionStorage.getItem(USER_SOURCE_KEY) ?? "";
          properties[USER_MEDIUM_KEY] =
            userMedium ?? sessionStorage.getItem(USER_MEDIUM_KEY) ?? "";
          window?.DD_LOGS?.logger?.info(
            `Launched application event - utm_source ${properties[USER_SOURCE_KEY]} - utm_medium ${properties[USER_MEDIUM_KEY]}`
          );
        }

        if (rewardsAccounts.length > 0) {
          properties.rewards_accounts = rewardsAccounts
            .map((r) => r.productDisplayName)
            .join(",");
          const earnMultiplier = (account: RewardsAccount) =>
            account.earn.hotelsMultiplier ?? -1;
          account = rewardsAccounts.sort(
            (prev, current) => earnMultiplier(current) - earnMultiplier(prev)
          )[0];
        }
        properties = addTrackingProperties(
          {
            ...stripBusinessTrackingProperties(expState.trackingProperties),
            ...businessExpState.trackingProperties,
          },
          properties
        );

        // Delete non-root session cookies to prevent inconsistent behavior on different paths
        deleteCookie("browser_session_id", "/hotels/availability");
        deleteCookie("browser_session_id", "/hotels/shop");
        deleteCookie("browser_session_id", "/hotels/book");
        deleteCookie("browser_session_id", "/flights/shop");
        deleteCookie("browser_session_id", "/cars/availability");

        const sessionId = getCookie("browser_session_id");
        if (!sessionId) {
          setCookie("browser_session_id", generateUserId());
        }

        let hasPaymentMethods = fetchedPaymentsList.hasCardOnFile;
        if (!fetchedPaymentsList.fetched) {
          // Set it before the await call, otherwise this codepath will still get triggered multiple times
          setFetchedPaymentsList({
            fetched: true,
            hasCardOnFile: fetchedPaymentsList.hasCardOnFile,
          });

          try {
            const payments = await listPaymentMethods();
            hasPaymentMethods = payments.length > 0;
            setFetchedPaymentsList({
              fetched: true,
              hasCardOnFile: hasPaymentMethods,
            });
          } catch (e) {
            console.error(e);
          }
        }

        const spendAndGetOfferData =
          isCorpTenant(config.TENANT) && isSpendAndGetOfferEnabled
            ? calculateSpendAndGetOfferTrackingData(
                creditHistory,
                walletDetails?.offers,
                onPortalSpend
              )
            : null;

        if (fetchedPaymentsList.fetched) {
          trackEvent({
            eventName: LAUNCHED_APPLICATION,
            properties: {
              ...properties,
              account_use_type: account?.accountUseType,
              account_allow_rewards_redemption: account?.allowRewardsRedemption,
              card_on_file: hasPaymentMethods,
              ...(spendAndGetOfferData !== null && {
                spend_and_get_offer_progress: spendAndGetOfferData.progress,
                spend_and_get_offer_max_credit_amount:
                  spendAndGetOfferData.maxCredits,
                spend_and_get_offer_cancelled: spendAndGetOfferData.cancelled,
              }),
            },
          });
        }

        setLaunchEventSent(true);
      }
    };

    doLaunch();
  }, [
    sessionInfo,
    expState,
    isFirstSession,
    launchEventSent,
    utmParams,
    setLaunchEventSent,
    rewardsAccounts,
    fetchedWalletDetails,
    fetchedPaymentsList.fetched,
    businessExpState?.trackingProperties,
  ]);

  useEffect(() => {
    const getUserPrefs = async () => {
      const userHotelPreferences = await fetchUserHotelPreferences();

      const hasSetHotelPreferences =
        !!userHotelPreferences?.amenities.length ||
        !!userHotelPreferences?.starRatings.length ||
        !!userHotelPreferences?.freeCancellationOnly;

      setUserHasNotSetHotelPreferences(!hasSetHotelPreferences);

      const userFlightPreferences = await fetchUserFlightPreferences();

      const hasSetFlightPreferences =
        !!userFlightPreferences.airlines.length ||
        !!userFlightPreferences.homeAirport ||
        userFlightPreferences.nonStopOnly ||
        Object.values(userFlightPreferences.fareClasses).some(
          (val) => val == true
        );

      setUserHasNotSetFlightPreferences(!hasSetFlightPreferences);
    };

    if (matchesMobile && isCustomerProfileExperiment) {
      getUserPrefs();
    }
  }, [matchesMobile, isCustomerProfileExperiment, pathname]);

  const displayCrossSellRV = React.useMemo(
    () => DISPLAY_CROSS_SELL_AND_RV_PATHS.includes(pathname),
    [pathname]
  );

  useEffect(() => {
    if (
      displayCrossSellRV &&
      rewardsAccounts.length > 0 &&
      isHotelCrossSellExperiment
    ) {
      const earnMultiplier = (account: RewardsAccount) =>
        account.earn.hotelsMultiplier ?? -1;
      const account = rewardsAccounts.sort(
        (prev, current) => earnMultiplier(current) - earnMultiplier(prev)
      )[0];
      const fetchCrossSell = async () => {
        const props: CrossSellProps | false = await fetchCrossSellInfoV3(
          account,
          isHotelCrossSellV3Enabled
        );
        if (props) {
          setCrossSellProps(props);
          setCrossSellLoaded(true);
        }
      };
      const properties: ProductFeedLoadingProperties = {
        feed_placement: "homepage",
        feed_type: "cross_sell_hotels",
      };
      trackEvent({ eventName: PRODUCT_FEED_LOADING, properties });
      fetchCrossSell();
    }
  }, [rewardsAccounts, isHotelCrossSellExperiment, displayCrossSellRV]);

  useEffect(() => {
    if (
      displayCrossSellRV &&
      rewardsAccounts.length > 0 &&
      isRecentlyViewedV1Experiment &&
      ((!matchesMobile && recentlyViewedDesktopP0Variant !== CONTROL) ||
        (matchesMobile && recentlyViewedMobileP0Variant !== CONTROL))
    ) {
      const earnMultiplier = (account: RewardsAccount) =>
        account.earn.hotelsMultiplier ?? -1;
      const account = rewardsAccounts.sort(
        (prev, current) => earnMultiplier(current) - earnMultiplier(prev)
      )[0];
      const fetchRecentViewsAndSearches = async () => {
        const props: RecentlyViewedAndSearchedProps | false =
          await fetchRecentlyViewedAndSearched(
            account,
            recentlyViewedDesktopP0Variant,
            isRecentlyViewedFlightsV2,
            isRecentlyViewedCarsV2,
            isPackagesExperiment,
            isExperiencesExperiment
          );

        if (props) {
          setRecentlyViewedAndSearchedProps(props);
          setRecentlyViewedLoaded(true);
        } else {
          setRecentlyViewedLoaded(true);
        }
      };
      const properties: ProductFeedLoadingProperties = {
        feed_placement: "homepage",
        feed_type: "recently_viewed",
      };
      trackEvent({ eventName: PRODUCT_FEED_LOADING, properties });
      fetchRecentViewsAndSearches();
    }
  }, [
    rewardsAccounts,
    isRecentlyViewedV1Experiment,
    recentlyViewedDesktopP0Variant,
    recentlyViewedMobileP0Variant,
    matchesMobile,
    displayCrossSellRV,
    isRecentlyViewedFlightsV2,
    isRecentlyViewedCarsV2,
  ]);

  useEffect(() => {
    const { assertion } = queryString.parse(window.location.search);

    // only fire expiring event if assertion token is not present
    // prevents firing event while we refresh the session
    if (!assertion) {
      const timeUntilExpiringEvent = dayjs(sessionInfo.sessionExpiration)
        .subtract(5, "minutes") // send event 5 minutes before expiration
        .diff();

      if (timeUntilExpiringEvent >= 0) {
        const timeout = setTimeout(() => {
          travelAppInterface.sendEvent({
            name: TravelAppInterfaceEventName.SESSION_EXPIRING,
          });
        }, timeUntilExpiringEvent);

        return () => clearTimeout(timeout);
      }
    }

    return () => {};
  }, [sessionInfo]);

  const isFetchingRewards = useMemo(
    () =>
      fetchRewardsAccountsCallState === CallState.NotCalled ||
      fetchRewardsAccountsCallState === CallState.InProcess,
    [fetchRewardsAccountsCallState]
  );

  const isHotelsOrStaysPath = (path: string) =>
    path === PATH_HOTELS || path === PATH_STAYS;
  const normalizePath = (path: string): string =>
    path.length > 1 && path.endsWith("/") ? path.slice(0, -1) : path;
  const HOMEPAGE_FUNNELS = {
    Activities: "Activities",
    PremiumStays: "PremiumStays",
    Cruises: "Cruises",
  } as const satisfies Record<
    string,
    NonNullable<React.ComponentProps<typeof HomepageV2>["activeFunnel"]>
  >;

  const homepageFunnelByPath = useMemo(
    () =>
      new Map<string, React.ComponentProps<typeof HomepageV2>["activeFunnel"]>([
        [
          normalizePath(PATH_FLIGHTS),
          Funnel.Air as React.ComponentProps<typeof HomepageV2>["activeFunnel"],
        ],
        [
          normalizePath(PATH_CARS),
          Funnel.Ground as React.ComponentProps<
            typeof HomepageV2
          >["activeFunnel"],
        ],
        [
          normalizePath(PATH_HOTELS),
          Funnel.Lodging as React.ComponentProps<
            typeof HomepageV2
          >["activeFunnel"],
        ],
        [
          normalizePath(PATH_STAYS),
          Funnel.Lodging as React.ComponentProps<
            typeof HomepageV2
          >["activeFunnel"],
        ],
        [normalizePath(PATH_ACTIVITIES), HOMEPAGE_FUNNELS.Activities],
        ...(isCorpTenant(config.TENANT)
          ? []
          : [
              [
                normalizePath(PATH_PREMIER_COLLECTION),
                HOMEPAGE_FUNNELS.PremiumStays,
              ] as const,
              [
                normalizePath(PATH_PREMIER_VACATION_RENTALS),
                HOMEPAGE_FUNNELS.PremiumStays,
              ] as const,
            ]),
        [normalizePath(PATH_CRUISES), HOMEPAGE_FUNNELS.Cruises],
        [
          normalizePath(packagesPath),
          Funnel.Package as React.ComponentProps<
            typeof HomepageV2
          >["activeFunnel"],
        ],
      ]),
    [packagesPath]
  );

  const homepagePaths = useMemo(
    () =>
      Array.from(
        new Set(
          Array.from(homepageFunnelByPath.keys()).flatMap((path) => [
            path,
            `${path}/`,
          ])
        )
      ),
    [homepageFunnelByPath]
  );

  const getHomepageActiveFunnel = (
    path: string
  ): React.ComponentProps<typeof HomepageV2>["activeFunnel"] | undefined =>
    homepageFunnelByPath.get(normalizePath(path));

  // manages the routing logic required for core-flights integration
  useEffect(() => {
    const { search } = window.location;
    const parsed = queryString.parse(search);
    const { tripCategory, flightShopProgress } = parsed;

    switch (pathname) {
      case PATH_FLIGHTS_SHOP: {
        // redirects user to new multi-city path based on trip category
        if (tripCategory === TripCategory.MULTI_CITY) {
          navigate(
            { pathname: PATH_FLIGHTS_SHOP_MULTICITY, search },
            { replace: true }
          );
        }
        // handles legacy FlightShop links for core-flights
        else if (showCoreFlights) {
          const flightShopSubPath = getCoreFlightsShopSubPath(
            parseInt(flightShopProgress as string, 10)
          );
          const searchString = getCoreFlightsSearchQueryString(parsed);

          navigate(
            {
              pathname: `${PATH_FLIGHTS_SHOP}${flightShopSubPath}`,
              search: searchString,
            },
            { replace: true }
          );
        }
        break;
      }
      default:
        break;
    }
  }, [pathname, window.location.search, showCoreFlights, navigate]);

  return (
    <main className={clsx("main-body", classes.main, className)}>
      {isInMaintenance ? (
        <Maintenance />
      ) : (
        <Grid className={clsx("main-body-content", classes.content)}>
          <Switch>
            <RouteV5 exact path={PATH_WEBVIEW} render={() => <div />} />
            {isCorpTenant(config.TENANT) ? (
              <RouteV5
                path={PATH_PACKAGES}
                render={(browserRouterProps: RouteComponentProps) => {
                  const legacyPackagesSubpath =
                    browserRouterProps.location.pathname.replace(
                      /^\/packages\/?/,
                      ""
                    );

                  return (
                    <Redirect
                      to={`${PATH_HOTELS_FLIGHTS}${legacyPackagesSubpath}${browserRouterProps.location.search}`}
                    />
                  );
                }}
              />
            ) : null}
            {showCoreHomepage ? (
              <RouteV5
                exact
                path={homepagePaths}
                render={(browserRouterProps: RouteComponentProps) =>
                  renderCoreHomepage(
                    browserRouterProps.location.pathname,
                    getHomepageActiveFunnel(
                      browserRouterProps.location.pathname
                    )
                  )
                }
              />
            ) : null}
            {showCoreFlights ? (
              <RouteV5
                path={PATH_DISRUPTION_OFFER}
                render={(browserRouterProps: RouteComponentProps) =>
                  flightsMaintenance ? (
                    <Maintenance />
                  ) : (
                    <FlightsModule
                      crossSellLoaded={false}
                      language={language}
                      experiments={expState}
                      recentlyViewedLoaded={false}
                      annualTravelCreditLoaded={false}
                      showCoreHomepage={showCoreHomepage}
                      {...browserRouterProps}
                    />
                  )
                }
              />
            ) : null}
            {showCoreFlights ? (
              <RouteV5
                path={PATH_CFAR_OFFER}
                render={(browserRouterProps: RouteComponentProps) =>
                  flightsMaintenance ? (
                    <Maintenance />
                  ) : (
                    <FlightsModule
                      crossSellLoaded={false}
                      language={language}
                      experiments={expState}
                      recentlyViewedLoaded={false}
                      annualTravelCreditLoaded={false}
                      showCoreHomepage={showCoreHomepage}
                      {...browserRouterProps}
                    />
                  )
                }
              />
            ) : null}
            {showCoreFlights ? (
              <RouteV5
                path={PATH_FLIGHTS_BOOK}
                render={(browserRouterProps: RouteComponentProps) =>
                  flightsMaintenance ? (
                    <Maintenance />
                  ) : (
                    <LegacyFlightsBooking
                      language={language}
                      {...browserRouterProps}
                      experiments={expState}
                      crossSellLoaded={false}
                      recentlyViewedLoaded={false}
                      annualTravelCreditLoaded={false}
                    />
                  )
                }
              />
            ) : null}
            {showCoreFlights ? (
              <RouteV5
                exact
                path={[PATH_FLIGHTS]}
                render={() => {
                  if (flightsMaintenance) {
                    return <Maintenance />;
                  }
                  const homePageContent = (
                    <HomePage
                      type={LandingPageType.FLIGHTS}
                      rewardsAccounts={rewardsAccounts}
                      selectedRewardsAccountId={selectedRewardsAccountId}
                      fetchRewardsAccountsCallState={
                        fetchRewardsAccountsCallState
                      }
                      walletDetails={walletDetails}
                      crossSellProps={crossSellProps}
                      recentlyViewedAndSearchedProps={
                        recentlyViewedAndSearchedProps
                      }
                      recentlyViewedAndSearchedLoaded={recentlyViewedLoaded}
                    />
                  );
                  return homePageContent;
                }}
              />
            ) : (
              <RouteV5
                exact
                path={PATH_FLIGHTS_SEARCH}
                render={(browserRouterProps: RouteComponentProps) =>
                  flightsMaintenance ? (
                    <Maintenance />
                  ) : matchesMobile ? (
                    <FlightsModule
                      crossSellLoaded={false}
                      language={language}
                      experiments={expState}
                      recentlyViewedLoaded={false}
                      annualTravelCreditLoaded={false}
                      showCoreHomepage={showCoreHomepage}
                      {...browserRouterProps}
                    />
                  ) : (
                    <Redirect to={PATH_FLIGHTS} />
                  )
                }
              />
            )}

            {showCoreFlights ? (
              <CompatRoute path={PATH_FLIGHTS}>
                {flightsMaintenance ? (
                  <Maintenance />
                ) : (
                  <Suspense fallback={null}>
                    {getFlightsAppByTenant(config.TENANT)}
                  </Suspense>
                )}
              </CompatRoute>
            ) : (
              <RouteV5
                path={PATH_FLIGHTS}
                render={(browserRouterProps: RouteComponentProps) =>
                  flightsMaintenance ? (
                    <Maintenance />
                  ) : !showFlightsFunnel ? (
                    <Redirect to={getRedirectPath()} />
                  ) : matchesMobile &&
                    browserRouterProps.history.location.pathname ===
                      PATH_FLIGHTS ? (
                    <>
                      <MobileLandingPage
                        type={LandingPageType.FLIGHTS}
                        rewardsAccounts={rewardsAccounts}
                        selectedRewardsAccountId={selectedRewardsAccountId}
                        recentlyViewedAndSearchedProps={
                          recentlyViewedAndSearchedProps
                        }
                        fetchRewardsAccountsCallState={
                          fetchRewardsAccountsCallState
                        }
                        recentlyViewedAndSearchedLoaded={recentlyViewedLoaded}
                      />
                      {isHotelCrossSellExperiment && crossSellProps ? (
                        <HomepageHotelCrossSell {...crossSellProps} />
                      ) : null}
                    </>
                  ) : (
                    <>
                      <FlightsModule
                        language={language}
                        experiments={expState}
                        crossSellLoaded={crossSellLoaded}
                        recentlyViewedLoaded={
                          (recentlyViewedLoaded &&
                            !!recentlyViewedAndSearchedProps?.recentSearchesAndViews) ||
                          isCorpTenant(config.TENANT)
                        }
                        annualTravelCreditLoaded={atcBannerVisible}
                        showCoreHomepage={showCoreHomepage}
                        {...browserRouterProps}
                      />
                      <FdrSearchBannerPortal
                        active={
                          isCorpTenant(config.TENANT) &&
                          browserRouterProps.history.location.pathname ===
                            PATH_FLIGHTS
                        }
                      />
                      {walletDetails &&
                        browserRouterProps.history.location.pathname ===
                          PATH_FLIGHTS && (
                          <HomepageAnnualTravelCredit
                            firstName={sessionInfo.userInfo.firstName}
                            rewardsAccounts={rewardsAccounts}
                            walletDetails={walletDetails}
                            isAnnualTravelCreditsExperiment={
                              isAnnualTravelCreditsExperiment
                            }
                            onChangeVisibleBanners={(banners) =>
                              setAtcBannerVisible(banners.length > 0)
                            }
                            onFtuxModalOpenChange={setOpenTravelCreditFTUX}
                          />
                        )}
                      {isTravelAppGTMEnabled &&
                        browserRouterProps.history.location.pathname ===
                          PATH_FLIGHTS && (
                          <TravelAppFTUXModal
                            isAnyOtherFtuxOpen={openTravelCreditFTUX}
                            currentRoute={
                              browserRouterProps.history.location.pathname
                            }
                            trackEvent={trackEvent}
                          />
                        )}

                      {isTravelSaleEnabled &&
                        browserRouterProps.history.location.pathname ===
                          PATH_FLIGHTS && (
                          <HomepageTravelSale
                            active={travelSaleVariant === TRAVEL_SALE_ACTIVE}
                            offers={walletDetails?.offers || []}
                          />
                        )}
                      {browserRouterProps.history.location.pathname ===
                        PATH_FLIGHTS && getAdsCarouselByTenant(config.TENANT)}
                      {isHotelCrossSellExperiment &&
                      showCrossSellV3UI &&
                      !!crossSellProps &&
                      browserRouterProps.history.location.pathname ===
                        PATH_FLIGHTS ? (
                        <HomepageHotelCrossSell {...crossSellProps} />
                      ) : null}
                      {browserRouterProps.history.location.pathname ===
                        PATH_FLIGHTS && (
                        <CorpHomePageTopSection
                          sessionInfo={sessionInfo}
                          trackEvent={trackEvent}
                          funnel={Funnel.Air}
                          accounts={rewardsAccounts}
                          selectedAccountReferenceId={selectedRewardsAccountId}
                        />
                      )}
                      {recentlyViewedDesktopP0Variant !== CONTROL &&
                      rewardsAccounts &&
                      browserRouterProps.history.location.pathname ===
                        PATH_FLIGHTS ? (
                        <RecentlyViewedAndSearched
                          {...recentlyViewedAndSearchedProps}
                          loading={!recentlyViewedLoaded}
                          showSkeleton={isCorpTenant(config.TENANT)}
                        />
                      ) : null}
                      {browserRouterProps.history.location.pathname ===
                        PATH_FLIGHTS && (
                        <CorpHomePageBottomSection
                          sessionInfo={sessionInfo}
                          rewardsAccounts={rewardsAccounts}
                        />
                      )}
                      {isHotelCrossSellExperiment &&
                      !showCrossSellV3UI &&
                      !!crossSellProps &&
                      browserRouterProps.history.location.pathname ===
                        PATH_FLIGHTS ? (
                        <HomepageHotelCrossSell {...crossSellProps} />
                      ) : null}
                    </>
                  )
                }
              />
            )}

            {showCoreHotels ? (
              <RouteV5
                path={[PATH_STAYS_BOOK, PATH_HOTELS_BOOK]}
                render={(browserRouterProps: RouteComponentProps) =>
                  hotelsMaintenance ? (
                    <Maintenance />
                  ) : (
                    <LegacyStaysBooking
                      language={language}
                      {...browserRouterProps}
                      experiments={expState}
                      crossSellLoaded={false}
                      recentlyViewedLoaded={false}
                      annualTravelCreditLoaded={false}
                    />
                  )
                }
              />
            ) : null}
            {showCoreHotels ? (
              <RouteV5
                exact
                path={[PATH_HOTELS, PATH_STAYS]}
                render={() => {
                  if (hotelsMaintenance) {
                    return <Maintenance />;
                  }
                  return (
                    <HomePage
                      type={LandingPageType.STAYS}
                      selectedRewardsAccountId={selectedRewardsAccountId}
                      rewardsAccounts={rewardsAccounts}
                      fetchRewardsAccountsCallState={
                        fetchRewardsAccountsCallState
                      }
                      walletDetails={walletDetails}
                      crossSellProps={crossSellProps}
                      recentlyViewedAndSearchedProps={
                        recentlyViewedAndSearchedProps
                      }
                      recentlyViewedAndSearchedLoaded={recentlyViewedLoaded}
                    />
                  );
                }}
              />
            ) : (
              <RouteV5
                exact
                path={[PATH_HOTELS_SEARCH, PATH_STAYS_SEARCH]}
                render={(browserRouterProps: RouteComponentProps) =>
                  hotelsMaintenance ? (
                    <Maintenance />
                  ) : matchesMobile ? (
                    <HotelsModule
                      language={language}
                      {...browserRouterProps}
                      experiments={expState}
                      crossSellLoaded={false}
                      recentlyViewedLoaded={false}
                      annualTravelCreditLoaded={false}
                    />
                  ) : (
                    <Redirect to={PATH_HOTELS} />
                  )
                }
              />
            )}

            {/* CompatRoutes can’t be wrapped in a <Switch /> or a fragment, as that prevents Redirect from working properly */}
            {showCoreHotels ? (
              <RouteV5
                exact
                path={PATH_HOTELS}
                render={() =>
                  hotelsMaintenance ? (
                    <Maintenance />
                  ) : (
                    <HomePage
                      type={LandingPageType.HOTELS}
                      rewardsAccounts={rewardsAccounts}
                      selectedRewardsAccountId={selectedRewardsAccountId}
                      fetchRewardsAccountsCallState={
                        fetchRewardsAccountsCallState
                      }
                      walletDetails={walletDetails}
                      crossSellProps={crossSellProps}
                      recentlyViewedAndSearchedProps={
                        recentlyViewedAndSearchedProps
                      }
                      recentlyViewedAndSearchedLoaded={recentlyViewedLoaded}
                    />
                  )
                }
              />
            ) : null}
            {showCoreHotels ? (
              <RouteV5
                exact
                path={PATH_STAYS}
                render={() =>
                  hotelsMaintenance ? (
                    <Maintenance />
                  ) : (
                    <HomePage
                      type={LandingPageType.STAYS}
                      rewardsAccounts={rewardsAccounts}
                      selectedRewardsAccountId={selectedRewardsAccountId}
                      fetchRewardsAccountsCallState={
                        fetchRewardsAccountsCallState
                      }
                      walletDetails={walletDetails}
                      crossSellProps={crossSellProps}
                      recentlyViewedAndSearchedProps={
                        recentlyViewedAndSearchedProps
                      }
                      recentlyViewedAndSearchedLoaded={recentlyViewedLoaded}
                    />
                  )
                }
              />
            ) : null}
            {showCoreHotels ? (
              // for legacy hotels base route
              <CompatRoute path={PATH_HOTELS}>
                {hotelsMaintenance ? (
                  <Maintenance />
                ) : (
                  <Suspense fallback={null}>
                    {getHotelsAppByTenant(config.TENANT)}
                  </Suspense>
                )}
              </CompatRoute>
            ) : null}
            {showCoreHotels ? (
              <CompatRoute path={PATH_STAYS}>
                {hotelsMaintenance ? (
                  <Maintenance />
                ) : (
                  <Suspense fallback={null}>
                    {getHotelsAppByTenant(config.TENANT)}
                  </Suspense>
                )}
              </CompatRoute>
            ) : null}
            {!showCoreHotels ? (
              <RouteV5
                path={[PATH_HOTELS, PATH_STAYS, PATH_FAVORITES]}
                render={(browserRouterProps: RouteComponentProps) => {
                  if (
                    isCorpTenant(config.TENANT) &&
                    browserRouterProps.location.pathname.startsWith("/stays") &&
                    !staysHomepageEnabled
                  ) {
                    return <Redirect to="/hotels" />;
                  }
                  return hotelsMaintenance ? (
                    <Maintenance />
                  ) : !showHotelsFunnel ? (
                    <Redirect to={getRedirectPath()} />
                  ) : matchesMobile &&
                    isHotelsOrStaysPath(
                      browserRouterProps.history.location.pathname
                    ) ? (
                    <>
                      <MobileLandingPage
                        type={
                          isHotelsOrStaysPath(
                            browserRouterProps.history.location.pathname
                          )
                            ? staysHomepageEnabled
                              ? LandingPageType.STAYS
                              : LandingPageType.HOTELS
                            : LandingPageType.HOTELS
                        }
                        rewardsAccounts={rewardsAccounts}
                        selectedRewardsAccountId={selectedRewardsAccountId}
                        recentlyViewedAndSearchedProps={
                          recentlyViewedAndSearchedProps
                        }
                        fetchRewardsAccountsCallState={
                          fetchRewardsAccountsCallState
                        }
                        recentlyViewedAndSearchedLoaded={recentlyViewedLoaded}
                      />
                      {isHotelCrossSellExperiment && crossSellProps ? (
                        <HomepageHotelCrossSell {...crossSellProps} />
                      ) : null}
                    </>
                  ) : (
                    <>
                      <HotelsModule
                        language={language}
                        crossSellLoaded={crossSellLoaded}
                        recentlyViewedLoaded={
                          (recentlyViewedLoaded &&
                            !!recentlyViewedAndSearchedProps?.recentSearchesAndViews) ||
                          isCorpTenant(config.TENANT)
                        }
                        annualTravelCreditLoaded={atcBannerVisible}
                        {...browserRouterProps}
                        experiments={expState}
                      />
                      {walletDetails &&
                        isHotelsOrStaysPath(
                          browserRouterProps.history.location.pathname
                        ) && (
                          <HomepageAnnualTravelCredit
                            firstName={sessionInfo.userInfo.firstName}
                            rewardsAccounts={rewardsAccounts}
                            walletDetails={walletDetails}
                            isAnnualTravelCreditsExperiment={
                              isAnnualTravelCreditsExperiment
                            }
                            onChangeVisibleBanners={(banners) => {
                              setAtcBannerVisible(banners.length > 0);
                            }}
                            onFtuxModalOpenChange={setOpenTravelCreditFTUX}
                          />
                        )}
                      {isTravelSaleEnabled &&
                        isHotelsOrStaysPath(
                          browserRouterProps.history.location.pathname
                        ) && (
                          <HomepageTravelSale
                            active={travelSaleVariant === TRAVEL_SALE_ACTIVE}
                            offers={walletDetails?.offers || []}
                          />
                        )}
                      {isHotelCrossSellExperiment &&
                      showCrossSellV3UI &&
                      crossSellProps &&
                      isHotelsOrStaysPath(
                        browserRouterProps.history.location.pathname
                      ) ? (
                        <HomepageHotelCrossSell {...crossSellProps} />
                      ) : null}
                      {isTravelAppGTMEnabled &&
                        isHotelsOrStaysPath(
                          browserRouterProps.history.location.pathname
                        ) && (
                          <TravelAppFTUXModal
                            isAnyOtherFtuxOpen={openTravelCreditFTUX}
                            currentRoute={
                              browserRouterProps.history.location.pathname
                            }
                            trackEvent={trackEvent}
                          />
                        )}
                      {isHotelsOrStaysPath(
                        browserRouterProps.history.location.pathname
                      ) && (
                        <CorpHomePageTopSection
                          sessionInfo={sessionInfo}
                          trackEvent={trackEvent}
                          funnel={Funnel.Lodging}
                          accounts={rewardsAccounts}
                          selectedAccountReferenceId={selectedRewardsAccountId}
                        />
                      )}
                      {isHotelsOrStaysPath(
                        browserRouterProps.history.location.pathname
                      ) && getAdsCarouselByTenant(config.TENANT)}
                      {recentlyViewedDesktopP0Variant !== CONTROL &&
                      rewardsAccounts &&
                      isHotelsOrStaysPath(
                        browserRouterProps.history.location.pathname
                      ) ? (
                        <RecentlyViewedAndSearched
                          {...recentlyViewedAndSearchedProps}
                          loading={!recentlyViewedLoaded}
                          showSkeleton={isCorpTenant(config.TENANT)}
                        />
                      ) : null}
                      {isHotelsOrStaysPath(
                        browserRouterProps.history.location.pathname
                      ) && (
                        <CorpHomePageBottomSection
                          sessionInfo={sessionInfo}
                          rewardsAccounts={rewardsAccounts}
                        />
                      )}
                      {isHotelCrossSellExperiment &&
                      !showCrossSellV3UI &&
                      crossSellProps &&
                      isHotelsOrStaysPath(
                        browserRouterProps.history.location.pathname
                      ) ? (
                        <HomepageHotelCrossSell {...crossSellProps} />
                      ) : null}
                    </>
                  );
                }}
              />
            ) : null}

            <RouteV5
              path={PATH_CARS_BOOK}
              render={(browserRouterProps: RouteComponentProps) =>
                carsMaintenance ? (
                  <Maintenance />
                ) : (
                  <LegacyCarsBooking
                    language={language}
                    {...browserRouterProps}
                    experiments={expState}
                    crossSellLoaded={false}
                    recentlyViewedLoaded={false}
                    annualTravelCreditLoaded={false}
                  />
                )
              }
            />
            <RouteV5
              exact
              path={PATH_CARS}
              render={() =>
                carsMaintenance ? (
                  <Maintenance />
                ) : (
                  <HomePage
                    type={LandingPageType.CARS}
                    rewardsAccounts={rewardsAccounts}
                    selectedRewardsAccountId={selectedRewardsAccountId}
                    fetchRewardsAccountsCallState={
                      fetchRewardsAccountsCallState
                    }
                    walletDetails={walletDetails}
                    crossSellProps={crossSellProps}
                    recentlyViewedAndSearchedProps={
                      recentlyViewedAndSearchedProps
                    }
                    recentlyViewedAndSearchedLoaded={recentlyViewedLoaded}
                  />
                )
              }
            />
            <CompatRoute path={PATH_CARS}>
              {carsMaintenance ? (
                <Maintenance />
              ) : (
                <Suspense fallback={null}>
                  {getCarsAppByTenant(config.TENANT)}
                </Suspense>
              )}
            </CompatRoute>
            {showCoreLuxuryMobileHomepageSearch ? (
              <CompatRoute path={PATH_PREMIER_COLLECTION}>
                <Suspense fallback={null}>
                  {getPremiumStaysAppByTenant(config.TENANT)}
                </Suspense>
              </CompatRoute>
            ) : null}
            <RouteV5
              exact
              path={[
                PATH_PREMIER_COLLECTION_SEARCH,
                PATH_PREMIER_VACATION_RENTALS_SEARCH,
                PATH_PREMIUM_OFFERS_SHOP,
              ]}
              render={(browserRouterProps: RouteComponentProps) => {
                // showCorePremiumStays already excludes these paths when experiment is on
                const isEligibleViaExperiments =
                  isPremierCollectionEnabled || isLifestyleCollectionEnabled;
                const isEligibleViaAPI = isLifestyleEligible === true;

                if (
                  showPremiumStaysFunnel &&
                  (isEligibleViaAPI || isEligibleViaExperiments)
                ) {
                  return (
                    <PremierCollectionModule
                      language={language}
                      // eslint-disable-next-line react/jsx-props-no-spreading
                      {...browserRouterProps}
                      experiments={expState}
                      showCoreHomepage={showCoreHomepage}
                    />
                  );
                }

                // Wait for both rewards and eligibility before redirecting
                return isFetchingRewards ||
                  (showPremiumStaysFunnel &&
                    isCheckingEligibility &&
                    !isEligibleViaExperiments) ? (
                  <div>Loading...</div>
                ) : (
                  <Redirect to={getRedirectPath()} />
                );
              }}
            />
            {showCorePremiumStays ? (
              <CompatRoute path={PATH_PREMIER_COLLECTION}>
                <Suspense fallback={null}>
                  {getPremiumStaysAppByTenant(config.TENANT)}
                </Suspense>
              </CompatRoute>
            ) : null}
            {showCoreLuxuryHotelsShop ? (
              <CompatRoute path={PATH_PREMIER_COLLECTION}>
                <Suspense fallback={null}>
                  {getPremiumStaysAppByTenant(config.TENANT)}
                </Suspense>
              </CompatRoute>
            ) : null}
            {showCoreLuxuryHotelsAvailability ? (
              <CompatRoute path={PATH_PREMIER_COLLECTION}>
                <Suspense fallback={null}>
                  {getPremiumStaysAppByTenant(config.TENANT)}
                </Suspense>
              </CompatRoute>
            ) : null}
            {showCoreLuxuryVacationRentalsShop ? (
              <CompatRoute path={PATH_PREMIER_COLLECTION}>
                <Suspense fallback={null}>
                  {getPremiumStaysAppByTenant(config.TENANT)}
                </Suspense>
              </CompatRoute>
            ) : null}
            {showCoreLuxuryHotelsShopDetails ? (
              <CompatRoute path={PATH_PREMIER_COLLECTION}>
                <Suspense fallback={null}>
                  {getPremiumStaysAppByTenant(config.TENANT)}
                </Suspense>
              </CompatRoute>
            ) : null}
            {showCorePremiumStaysBook ? (
              <RouteV5
                path={PATH_PREMIER_COLLECTION_BOOK}
                render={(browserRouterProps: RouteComponentProps) =>
                  isInMaintenance ? (
                    <Maintenance />
                  ) : (
                    <LegacyPremierCollectionBook
                      language={language}
                      // eslint-disable-next-line react/jsx-props-no-spreading
                      {...browserRouterProps}
                      experiments={expState}
                      showCoreHomepage={showCoreHomepage}
                    />
                  )
                }
              />
            ) : null}
            {showCorePremiumStaysVrBook ? (
              <RouteV5
                path={PATH_PREMIER_VACATION_RENTALS_BOOK}
                render={(browserRouterProps: RouteComponentProps) =>
                  isInMaintenance ? (
                    <Maintenance />
                  ) : (
                    <LegacyPremierCollectionVRBook
                      language={language}
                      // eslint-disable-next-line react/jsx-props-no-spreading
                      {...browserRouterProps}
                      experiments={expState}
                      showCoreHomepage={showCoreHomepage}
                    />
                  )
                }
              />
            ) : null}
            <RouteV5
              path={PATH_PREMIER_COLLECTION}
              render={(browserRouterProps: RouteComponentProps) => {
                // When the book page is routed through the direct-import Legacy
                // wrapper above, skip the microfrontend here to avoid rendering
                // the book page twice. Only bail out once the user is eligible
                // (i.e. the Legacy route is actually rendering); otherwise fall
                // through so the eligibility loading/redirect logic below still
                // applies to the book path.
                if (showCorePremiumStaysBook || showCorePremiumStaysVrBook) {
                  return null;
                }

                if (
                  isCorpTenant(config.TENANT) &&
                  browserRouterProps.location.pathname === "/premium-stays/"
                ) {
                  return <Redirect to={PATH_HOTELS} />;
                }

                // Check if user is eligible via API or experiments
                const isEligibleViaExperiments =
                  isPremierCollectionEnabled || isLifestyleCollectionEnabled;
                const isEligibleViaAPI = isLifestyleEligible === true;

                // Wait for eligibility check if experiments don't grant access
                if (
                  showPremiumStaysFunnel &&
                  isCheckingEligibility &&
                  !isEligibleViaExperiments
                ) {
                  return <div>Loading...</div>;
                }

                if (
                  showPremiumStaysFunnel &&
                  (isEligibleViaAPI || isEligibleViaExperiments)
                ) {
                  if (
                    matchesMobile &&
                    browserRouterProps.history.location.pathname ===
                      PATH_PREMIER_COLLECTION
                  ) {
                    return (
                      <MobileLandingPage
                        type={LandingPageType.PREMIUM_STAYS}
                        rewardsAccounts={rewardsAccounts}
                        selectedRewardsAccountId={selectedRewardsAccountId}
                        recentlyViewedAndSearchedProps={
                          recentlyViewedAndSearchedProps
                        }
                        fetchRewardsAccountsCallState={
                          fetchRewardsAccountsCallState
                        }
                        recentlyViewedAndSearchedLoaded={recentlyViewedLoaded}
                      />
                    );
                  }
                  return (
                    <>
                      <PremierCollectionModule
                        language={language}
                        {...browserRouterProps}
                        experiments={expState}
                        showCoreHomepage={showCoreHomepage}
                      />
                      {walletDetails &&
                        browserRouterProps.history.location.pathname ===
                          PATH_PREMIER_COLLECTION && (
                          <HomepageAnnualTravelCredit
                            firstName={sessionInfo.userInfo.firstName}
                            rewardsAccounts={rewardsAccounts}
                            walletDetails={walletDetails}
                            isAnnualTravelCreditsExperiment={
                              isAnnualTravelCreditsExperiment
                            }
                            showBanner={false}
                            onFtuxModalOpenChange={setOpenTravelCreditFTUX}
                          />
                        )}
                    </>
                  );
                }
                return isFetchingRewards ? (
                  <div>Loading...</div> // TODO: Add loading component
                ) : (
                  ([CallState.Success, CallState.Failed].includes(
                    expState.callState
                  ) ||
                    expState.experiments.length > 0) && (
                    <Redirect to={getRedirectPath()} />
                  )
                );
              }}
            />
            {showCoreVacationRentalsShop ? (
              <CompatRoute path={PATH_VACATION_RENTALS}>
                <Suspense fallback={null}>
                  {getVacationRentalsAppByTenant(config.TENANT)}
                </Suspense>
              </CompatRoute>
            ) : null}
            <RouteV5
              path={PATH_VACATION_RENTALS}
              render={(browserRouterProps: RouteComponentProps) =>
                showCoreVacationRentalsShop &&
                browserRouterProps.location.pathname.startsWith(
                  PATH_VACATION_RENTALS_SHOP
                ) ? null : (
                  <VacationRentalsModule
                    experiments={expState}
                    language={language}
                    showCoreHomepage={showCoreHomepage}
                    {...browserRouterProps}
                  />
                )
              }
            />
            {showCorpMyTrips ? (
              <RouteV5
                path={PATH_TRIPS_DISRUPTION_PROTECTION_OVERVIEW}
                render={(browserRouterProps: RouteComponentProps) => (
                  <TripsModule
                    experiments={expState}
                    language={language}
                    showCoreHomepage={showCoreHomepage}
                    {...browserRouterProps}
                  />
                )}
              />
            ) : null}
            {showCorpMyTrips ? (
              <CompatRoute path={PATH_TRIPS}>
                <Suspense fallback={null}>
                  <CorpMyTripsApp
                    onNavigateToDisruption={goToDisruptionProtection}
                  />
                </Suspense>
              </CompatRoute>
            ) : null}
            <RouteV5
              path={PATH_TRIPS}
              render={(browserRouterProps: RouteComponentProps) =>
                tripsMaintenance ? (
                  <Maintenance />
                ) : showCorpMyTrips ? null : (
                  <TripsModule
                    experiments={expState}
                    language={language}
                    showCoreHomepage={showCoreHomepage}
                    {...browserRouterProps}
                  />
                )
              }
            />
            <CompatRoute path={PATH_BUSINESS}>
              {isCorpTenant(config.TENANT) ? (
                <BusinessApp />
              ) : (
                <Redirect to={getRedirectPath()} />
              )}
            </CompatRoute>
            {isCorpTenant(config.TENANT) ? (
              <CompatRoute path={PATH_MY_PROFILE}>
                {!isMyProfilePageResolved ? null : isMyProfilePageAvailable ? (
                  <Suspense fallback={null}>
                    <MyProfileApp />
                  </Suspense>
                ) : (
                  <Redirect to={PATH_HOTELS} />
                )}
              </CompatRoute>
            ) : null}
            <RouteV5
              path={[PATH_TERMS, PATH_TERMS_OF_SERVICE, PATH_SITE_TERMS_OF_USE]}
              render={(browserRouterProps: RouteComponentProps) => (
                <TermsModule
                  language={language}
                  experiments={expState}
                  authenticated={!notAuthenticated}
                  travelWalletOffers={walletDetails?.offers ?? []}
                  {...browserRouterProps}
                />
              )}
            />
            <CompatRoute path={PATH_CORP_FAQ}>
              {isCorpTenant(config.TENANT) ? (
                <CorporateFAQ />
              ) : (
                <Redirect to={getRedirectPath()} />
              )}
            </CompatRoute>
            <RouteV5
              path={PATH_EXCHANGE}
              render={(browserRouterProps: RouteComponentProps) => (
                <ExchangeModule
                  experiments={expState}
                  language={language}
                  {...browserRouterProps}
                />
              )}
            />
            <RouteV5
              exact
              path={PATH_TRAVEL_SALE}
              render={(browserRouterProps: RouteComponentProps) => {
                if (isTravelSaleEnabled) {
                  return (
                    <TravelWalletModule
                      language={language}
                      {...browserRouterProps}
                      experiments={expState}
                    />
                  );
                }
                return isFetchingRewards ? (
                  <div>Loading...</div> // TODO: Add loading component
                ) : (
                  <Redirect to={PATH_HOTELS} />
                );
              }}
            />
            <RouteV5
              path={PATH_TRAVEL_WALLET}
              render={(browserRouterProps: RouteComponentProps) => (
                <TravelWalletModule
                  experiments={expState}
                  language={language}
                  {...browserRouterProps}
                />
              )}
            />
            <RouteV5
              path={PATH_CUSTOMER_PROFILE}
              render={(browserRouterProps: RouteComponentProps) =>
                isCorpTenant(config.TENANT) ? null : (
                  <CustomerProfileModule
                    experiments={expState}
                    language={language}
                    showCoreHomepage={showCoreHomepage}
                    {...browserRouterProps}
                  />
                )
              }
            />
            {showCorePackages ? (
              <RouteV5
                exact
                path={packagesPath}
                render={() =>
                  packagesMaintenance ? (
                    <Maintenance />
                  ) : (
                    <HomePage
                      type={LandingPageType.PACKAGES}
                      rewardsAccounts={rewardsAccounts}
                      selectedRewardsAccountId={selectedRewardsAccountId}
                      fetchRewardsAccountsCallState={
                        fetchRewardsAccountsCallState
                      }
                      walletDetails={walletDetails}
                      crossSellProps={crossSellProps}
                      recentlyViewedAndSearchedProps={
                        recentlyViewedAndSearchedProps
                      }
                      recentlyViewedAndSearchedLoaded={recentlyViewedLoaded}
                    />
                  )
                }
              />
            ) : null}
            {showCorePackages ? (
              <RouteV5
                path={[
                  PATH_PACKAGES_BOOK,
                  PATH_PACKAGES_BOOK_CONFIRMATION,
                  PATH_PACKAGE_REVIEW,
                  PATH_HOTELS_FLIGHTS_BOOK,
                  PATH_HOTELS_FLIGHTS_BOOK_CONFIRMATION,
                  PATH_HOTELS_FLIGHTS_REVIEW,
                ]}
                render={(browserRouterProps: RouteComponentProps) =>
                  packagesMaintenance ? (
                    <Maintenance />
                  ) : (
                    <LegacyPackagesBooking
                      language={language}
                      {...browserRouterProps}
                      experiments={expState}
                      showCoreHomepage={showCoreHomepage}
                    />
                  )
                }
              />
            ) : null}
            {showCorePackages ? (
              <CompatRoute path={packagesPath}>
                {packagesMaintenance ? (
                  <Maintenance />
                ) : (
                  <Suspense fallback={null}>
                    {getPackagesAppByTenant(config.TENANT)}
                  </Suspense>
                )}
              </CompatRoute>
            ) : (
              <RouteV5
                exact
                path={packagesSearchPath}
                render={(browserRouterProps: RouteComponentProps) =>
                  packagesMaintenance ? (
                    <Maintenance />
                  ) : isPackagesExperiment ? (
                    matchesMobile ? (
                      <PackagesModule
                        experiments={expState}
                        language={language}
                        recentlyViewedLoaded={false}
                        showCoreHomepage={showCoreHomepage}
                        {...browserRouterProps}
                      />
                    ) : (
                      <Redirect to={packagesPath} />
                    )
                  ) : (
                    <Redirect to={getRedirectPath()} />
                  )
                }
              />
            )}
            {!showCorePackages ? (
              <RouteV5
                path={packagesPath}
                render={(browserRouterProps: RouteComponentProps) =>
                  packagesMaintenance ? (
                    <Maintenance />
                  ) : isPackagesExperiment ? (
                    matchesMobile &&
                    browserRouterProps.history.location.pathname ===
                      packagesPath ? (
                      <MobileLandingPage
                        type={LandingPageType.PACKAGES}
                        rewardsAccounts={rewardsAccounts}
                        selectedRewardsAccountId={selectedRewardsAccountId}
                        fetchRewardsAccountsCallState={
                          fetchRewardsAccountsCallState
                        }
                        recentlyViewedAndSearchedLoaded={recentlyViewedLoaded}
                      />
                    ) : (
                      <>
                        <PackagesModule
                          experiments={expState}
                          language={language}
                          recentlyViewedLoaded={
                            (recentlyViewedLoaded &&
                              !!recentlyViewedAndSearchedProps?.recentSearchesAndViews) ||
                            isCorpTenant(config.TENANT)
                          }
                          showCoreHomepage={showCoreHomepage}
                          {...browserRouterProps}
                        />
                        {browserRouterProps.history.location.pathname ===
                          packagesPath && (
                          <CorpHomePageTopSection
                            sessionInfo={sessionInfo}
                            trackEvent={trackEvent}
                            funnel={Funnel.Lodging}
                            accounts={rewardsAccounts}
                            selectedAccountReferenceId={
                              selectedRewardsAccountId
                            }
                          />
                        )}
                        {recentlyViewedDesktopP0Variant !== CONTROL &&
                        rewardsAccounts &&
                        browserRouterProps.history.location.pathname ===
                          packagesPath ? (
                          <RecentlyViewedAndSearched
                            {...recentlyViewedAndSearchedProps}
                            loading={!recentlyViewedLoaded}
                            showSkeleton={isCorpTenant(config.TENANT)}
                          />
                        ) : null}
                        {browserRouterProps.history.location.pathname ===
                          packagesPath && (
                          <CorpHomePageBottomSection
                            sessionInfo={sessionInfo}
                            rewardsAccounts={rewardsAccounts}
                          />
                        )}
                        {isTravelAppGTMEnabled &&
                          browserRouterProps.history.location.pathname ===
                            packagesPath && (
                            <TravelAppFTUXModal
                              isAnyOtherFtuxOpen={openTravelCreditFTUX}
                              currentRoute={
                                browserRouterProps.history.location.pathname
                              }
                              trackEvent={trackEvent}
                            />
                          )}
                      </>
                    )
                  ) : (
                    ([CallState.Success, CallState.Failed].includes(
                      expState.callState
                    ) ||
                      expState.experiments.length > 0) && (
                      <Redirect to={getRedirectPath()} />
                    )
                  )
                }
              />
            ) : null}
            {showCoreActivities ? (
              <RouteV5
                path={PATH_ACTIVITIES_BOOK}
                render={(browserRouterProps: RouteComponentProps) =>
                  activitiesMaintenance ? (
                    <Maintenance />
                  ) : (
                    <LegacyActivitiesBooking
                      language={language}
                      {...browserRouterProps}
                      experiments={expState}
                    />
                  )
                }
              />
            ) : null}
            {showCoreActivities ? (
              <RouteV5
                exact
                path={PATH_ACTIVITIES}
                render={() =>
                  activitiesMaintenance ? (
                    <Maintenance />
                  ) : (
                    <HomePage
                      type={LandingPageType.EXPERIENCES}
                      rewardsAccounts={rewardsAccounts}
                      selectedRewardsAccountId={selectedRewardsAccountId}
                      fetchRewardsAccountsCallState={
                        fetchRewardsAccountsCallState
                      }
                      walletDetails={walletDetails}
                      crossSellProps={crossSellProps}
                      recentlyViewedAndSearchedProps={
                        recentlyViewedAndSearchedProps
                      }
                      recentlyViewedAndSearchedLoaded={recentlyViewedLoaded}
                    />
                  )
                }
              />
            ) : null}
            {showCoreActivities ? (
              <CompatRoute path={PATH_ACTIVITIES}>
                {activitiesMaintenance ? (
                  <Maintenance />
                ) : (
                  getActivitiesAppByTenant(config.TENANT)
                )}
              </CompatRoute>
            ) : (
              <RouteV5
                path={PATH_ACTIVITIES}
                render={(browserRouterProps: RouteComponentProps) =>
                  activitiesMaintenance ? (
                    <Maintenance />
                  ) : isExperiencesExperiment ? (
                    matchesMobile &&
                    browserRouterProps.history.location.pathname ===
                      PATH_ACTIVITIES ? (
                      <MobileLandingPage
                        type={LandingPageType.EXPERIENCES}
                        rewardsAccounts={rewardsAccounts}
                        selectedRewardsAccountId={selectedRewardsAccountId}
                        fetchRewardsAccountsCallState={
                          fetchRewardsAccountsCallState
                        }
                        recentlyViewedAndSearchedLoaded={recentlyViewedLoaded}
                      />
                    ) : (
                      <>
                        <ExperiencesModule
                          experiments={expState}
                          language={language}
                          showCoreHomepage={showCoreHomepage}
                          {...browserRouterProps}
                        />
                        {browserRouterProps.history.location.pathname ===
                          PATH_ACTIVITIES && (
                          <CorpHomePageTopSection
                            sessionInfo={sessionInfo}
                            trackEvent={trackEvent}
                            funnel={Funnel.Experiences}
                            accounts={rewardsAccounts}
                            selectedAccountReferenceId={
                              selectedRewardsAccountId
                            }
                          />
                        )}
                        {browserRouterProps.history.location.pathname ===
                          PATH_ACTIVITIES &&
                        recentlyViewedDesktopP0Variant !== CONTROL &&
                        rewardsAccounts ? (
                          <RecentlyViewedAndSearched
                            {...recentlyViewedAndSearchedProps}
                            loading={!recentlyViewedLoaded}
                            showSkeleton={isCorpTenant(config.TENANT)}
                          />
                        ) : null}
                        {browserRouterProps.history.location.pathname ===
                          PATH_ACTIVITIES && (
                          <CorpHomePageBottomSection
                            sessionInfo={sessionInfo}
                            rewardsAccounts={rewardsAccounts}
                          />
                        )}
                        {isHotelCrossSellExperiment &&
                        browserRouterProps.history.location.pathname ===
                          PATH_ACTIVITIES &&
                        !showCrossSellV3UI &&
                        !!crossSellProps ? (
                          <HomepageHotelCrossSell {...crossSellProps} />
                        ) : null}
                      </>
                    )
                  ) : (
                    ([CallState.Success, CallState.Failed].includes(
                      expState.callState
                    ) ||
                      expState.experiments.length > 0) && (
                      <Redirect to={getRedirectPath()} />
                    )
                  )
                }
              />
            )}
            {showCoreCruises ? (
              <CompatRoute path={PATH_CRUISES}>
                <Suspense fallback={null}>
                  {getCruisesAppByTenant(config.TENANT)}
                </Suspense>
              </CompatRoute>
            ) : null}
            <CompatRoute path={PATH_TRAVEL_WALLET_V2}>
              {getTravelWalletAppByTenant(config.TENANT)}
            </CompatRoute>
            <RouteV5
              path={PATH_CORP_ACCESS_DENIED}
              render={() => <AccessDenied />}
            />
            <RouteV5
              path={PATH_CORP_ACCESS_DENIED_NOT_BETA}
              render={() => <AccessDeniedNotInBeta />}
            />
            {showCoreHomepage ? (
              <RouteV5
                exact
                path={PATH_HOME}
                render={() => renderCoreHomepage(PATH_HOME)}
              />
            ) : null}
            <RouteV5 path="*">
              {/* TODO: once we have started working on the new mobile search workflow changes, this component will likely be relocated
            so that RewardsBanner can be added to the mobile home page; see https://hopper-jira.atlassian.net/browse/BP-725 */}
              {matchesMobile ? (
                <>
                  <MobileLandingPage
                    type={getLandingPageType()}
                    rewardsAccounts={rewardsAccounts}
                    selectedRewardsAccountId={selectedRewardsAccountId}
                    recentlyViewedAndSearchedProps={
                      recentlyViewedAndSearchedProps
                    }
                    recentlyViewedAndSearchedLoaded={recentlyViewedLoaded}
                    fetchRewardsAccountsCallState={
                      fetchRewardsAccountsCallState
                    }
                  />
                  {isHotelCrossSellExperiment && crossSellProps ? (
                    <HomepageHotelCrossSell {...crossSellProps} />
                  ) : null}
                </>
              ) : (
                <Redirect to={getRedirectPath()} />
              )}
            </RouteV5>
          </Switch>
          <HomepageHeaderAccountNavPortal
            active={showCoreHomepage}
            slotId={FLIGHTS_HOMEPAGE_HEADER_ACCOUNT_NAV_SLOT_ID}
          />
          <HomepageHeaderAccountNavPortal
            active={showCoreHomepage}
            slotId={PACKAGES_HOMEPAGE_HEADER_ACCOUNT_NAV_SLOT_ID}
          />
          <HomepageHeaderAccountNavPortal
            active={showCoreHomepage}
            slotId={VACATION_RENTALS_HOMEPAGE_HEADER_ACCOUNT_NAV_SLOT_ID}
          />
          <HomepageHeaderAccountNavPortal
            active={showCoreHomepage}
            slotId={PREMIER_COLLECTION_HOMEPAGE_HEADER_ACCOUNT_NAV_SLOT_ID}
          />
          <HomepageHeaderAccountNavPortal
            active={showCoreHomepage}
            slotId={ACTIVITIES_HOMEPAGE_HEADER_ACCOUNT_NAV_SLOT_ID}
          />
          <PostBookingOfferModal
            history={history}
            showOnPaths={postBookingOfferModalConnectorPropsPropsShowOnPaths}
            getPostBookingOffer={() =>
              getPostBookingOffer({
                referenceDateTime: dayjs().format(),
              })
            }
            showRewardsMerch={showPostBookingPayByRewardsMerch}
            newAirCopy={isDisruptionAirCopyAvailable}
            isPostBookingOffersAvailable={isPostBookingOffersAvailable}
            trackEvent={trackEvent}
            governmentShutdownBannerVariant={
              postBookingGovernmentShutdownVariant
            }
            isFreeFdaExperimentEnabled={isFreeFdaEnabled}
          />
          {isCaponeTenant(config.TENANT) && (
            <CorporateSwitchModal open={showCorporateSwitchModal} />
          )}
        </Grid>
      )}
    </main>
  );
};

const getLandingScreen = (): LandingScreen => {
  const path = window.location.pathname;
  if (path.includes("flights")) {
    return path.includes("search") ? "flight_search" : "flight_shop";
  }
  if (path.includes("cars")) {
    return path.includes("search") ? "cars_search" : "cars_list";
  }
  if (path.includes("hotels")) {
    return path.includes("search") ? "hotel_search" : "hotel_list";
  }
  if (path.includes("trips")) {
    return "my_trips";
  }
  if (path.includes("exchange")) {
    return "exchange";
  }
  if (path.includes("travel-wallet")) {
    return "travel_wallet";
  }
  return "hotel_search";
};

export default Body;
